import axios from "axios";
import { baseUrlApi } from '../config';
import { mensagemDeErro } from '../utils/erroApi';
import { lerAvisosDoCabecalho } from './avisosCabecalho';

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.withCredentials = true;
const token = window.localStorage.getItem("token");
const userString = window.localStorage.getItem("user");
const user = JSON.parse(userString);

export const api = axios.create({
    baseURL: baseUrlApi,
    headers: {
        'X-Requested': 'XMLHttpRequest',
        'Authorization': `Bearer ${token}`
    },
});

// Interceptor: se o token expirou (401), força logout
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Evita loop se já estiver na tela de login
            if (!window.location.pathname.includes('/login')) {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);

/**
 * Usuário logado com as permissões ATUAIS do servidor.
 *
 * Usado pelo AuthProvider ao abrir o app, para não ficar preso na lista de
 * permissões que foi gravada no localStorage no dia do login.
 *
 * Devolve null em qualquer falha (rede, servidor fora, endpoint ainda não
 * deployado): quem chama simplesmente mantém o que já tinha em cache. O 401 é
 * exceção e continua caindo no interceptor acima, que derruba a sessão.
 */
export const getUsuarioLogado = async () => {
    try {
        // Timeout curto de proposito: o boot do app espera esta resposta para
        // decidir rota, entao ela nao pode segurar a tela numa rede ruim.
        const res = await api.get("/me", { timeout: 3000 });
        return res?.data?.data?.user || null;
    } catch (error) {
        console.error("Erro ao revalidar usuário logado:", error?.message || error);
        return null;
    }
};

export const createSession = async (email, password) => {
    try {
        const loginUser = await api.post("/auth/login", { email, password });
        if (loginUser.data.status === 401) {
            return false;
        } else if (loginUser.data.status === "403") {
            // Credencial certa, mas o admin bloqueou o acesso.
            return { erro: loginUser.data.message };
        } else {
            return loginUser;
        }
    } catch {
        return false;
    }
};

export const solicitarCodigoWhatsApp = async (email) => {
    try {
        const res = await api.post("/auth/solicitar-codigo", { email });
        return res.data;
    } catch {
        return { status: "error", message: "Erro de conexão" };
    }
};

export const validarCodigoWhatsApp = async (email, codigo) => {
    try {
        const res = await api.post("/auth/validar-codigo", { email, codigo });
        return res.data;
    } catch {
        return { status: "error", message: "Erro de conexão" };
    }
};

export const getProdutos = async (consulta) => {
    try {
        var res = await api.get(`/produto/${consulta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const getPerguntasML = async (status, conta, page = 1, anuncioId = '') => {
    try {
        let url = `/perguntas_mercado_livre/${status}?page=${page}`;

        if (conta && conta !== 'all') {
            url += `&conta=${conta}`;
        }
        if (anuncioId) {
            url += `&anuncio_id=${anuncioId}`;
        }

        const res = await api.get(url);

        if (res.status !== 200) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};
export const getMetricasPerguntas = async () => {
    try {
        const res = await api.get('/perguntas/metricas');
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao buscar métricas das perguntas:", error);
        return null;
    }
};

export const postResposta = async (id, resposta, conta, userId) => {
    try {
        const response = await api.post("/perguntas_mercado_livre", {
            'id': id,
            'resposta': resposta,
            'conta': conta,
            'userId': userId,
        });

        return { success: true, data: response.data };

    } catch (error) {
        console.error("Erro ao enviar resposta:", error.response);
        return {
            success: false,
            message: error.response?.data?.error || 'Erro de comunicação com o servidor.',
            details: error.response?.data?.details || ''
        };
    }
};

export const getSugestaoResposta = async (questionText, itemId) => { // Adiciona itemId
    try {
        const response = await api.post("/perguntas/sugerir-resposta", {
            question_text: questionText,
            ml_item_id: itemId, // Envia o ml_item_id
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Erro ao buscar sugestão:", error.response);
        return {
            success: false,
            message: error.response?.data?.error || 'Erro de comunicação com o servidor.',
        };
    }
};

export const getAnuncioDetalhes = async (itemId, conta) => {
    try {
        const res = await api.get(`/anuncio/${itemId}?conta=${conta}`);
        if (res.status === 200) {
            return { success: true, data: res.data };
        }
        return { success: false, message: 'Anúncio não encontrado.' };
    } catch (error) {
        console.error("Erro ao buscar detalhes do anúncio:", error);
        return { success: false, message: error.response?.data?.error || 'Falha ao buscar dados do anúncio.' };
    }
};


export const getVendasML = async (consulta, termoBusca) => {
    try {
        var res = await api.get(`/vendas/${consulta}`, {
            params: termoBusca ? { q: termoBusca } : {},
        });
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const setVendaCotacao = async (id, status) => {
    try {
        const res = await api.put("/cotacao", { id, status, userId: user.id });
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch {
        return false;
    }
};


export const getVenda = async (consulta) => {
    try {
        var res = await api.get(`/venda_mercado_livre/${consulta}`);
        if (res.status !== 200 || res.data.length === 0 || !('id' in res.data)) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const getDetalhesVenda = async (idVenda) => {
    try {
        const res = await api.get(`/vendas/${idVenda}/detalhes`);
        return res.data?.status ? res.data.data : { erro: res.data?.error || 'Não foi possível carregar os detalhes da venda.' };
    } catch (error) {
        return { erro: error.response?.data?.error || 'Não foi possível carregar os detalhes da venda.' };
    }
};

export const cancelarItemVenda = async (itemVendaId, payload) => {
    try {
        const res = await api.post(`/vendas/itens/${itemVendaId}/cancelar`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: 'O servidor não respondeu. Recarregue a venda para conferir se o item foi cancelado antes de tentar de novo.' };
    }
};

export const desfazerCancelamentoItemVenda = async (ocorrenciaId) => {
    try {
        const res = await api.post(`/vendas/ocorrencias/${ocorrenciaId}/desfazer`);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: 'O servidor não respondeu. Recarregue a venda para conferir antes de tentar de novo.' };
    }
};

export const getVendaManual = async (consulta) => {
    try {
        var res = await api.get(`/venda_manual/${consulta}`);
        if (res.status !== 200 || res.data.length === 0 || !('id' in res.data)) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


// itemVendaId opcional: marca o furo em UM item do pedido. Sem ele, o pedido inteiro.
export const setFuroEstoqueVenda = async (id, status, itemVendaId = null) => {
    try {
        const payload = { id, status, userId: user.id };
        if (itemVendaId) payload.itemVendaId = itemVendaId;
        const res = await api.put("/furo_estoque", payload);
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch {
        return false;
    }
};


export const setStatusTaga = async (id, status) => {
    try {
        const res = await api.put("/status_taga", { id, status, userId: user.id });
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch {
        return false;
    }
};


export const criarObsVenda = async (formData) => {
    try {
        const res = await api.post("/observacao_venda", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

// export const criarObsVenda = async (id, id_user, obs) => {
//     try {
//         const res = await api.post("/observacao_venda", { id, id_user, obs });
//         if (res.status !== 200 || res.data === false) {
//             return false;
//         } else {
//             return res.data;
//         }
//     } catch {
//         return false;
//     }
// };

export const apagarObsVenda = async (id) => {
    try {
        const res = await api.delete(`/observacao_venda/${id}`);
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true;
        }
    } catch {
        return false;
    }
};


export const getMensagemVenda = async (id) => {
    const res = await api.get(`/venda_mercado_livre/mensagens/${id}`);
    return res.data;
};

export const sincronizarMensagensVenda = async (id) => {
    const res = await api.post(`/venda_mercado_livre/mensagens/${id}/sincronizar`);
    return res.data;
};

export const enviarMensagemVenda = async (id, msg, tipo) => {
    const res = await api.post('/venda_mercado_livre/mensagens', {
        id, msg, tipo, userId: user.id,
    });
    return res.data;
};

export const enviarMensagemComAnexo = async (idOrigem, msg, file) => {
    const form = new FormData();
    form.append('id', idOrigem);
    form.append('msg', msg || '');
    form.append('user_id', user.id);
    if (file) form.append('file', file);
    const res = await api.post('/mensageria/com-anexo', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

export const getAnexoMensagemUrl = (filename, vendaId) =>
    `${api.defaults.baseURL}/mensageria/anexo/${encodeURIComponent(filename)}?venda_id=${vendaId}`;

export const getMensageriaNaoLidas = async () => {
    const res = await api.get('/mensageria/nao-lidas');
    return res.data;
};

export const getMensageriaConversas = async (params = {}) => {
    const res = await api.get('/mensageria/conversas', {
        params: { user_id: user.id, ...params },
    });
    return res.data;
};

export const marcarMensagemLida = async (packId) => {
    const res = await api.post('/mensageria/marcar-lida', {
        pack_id: packId,
        user_id: user.id,
    });
    return res.data;
};

export const getMensageriaStatusLeitura = async (packIds) => {
    const res = await api.get('/mensageria/status-leitura', {
        params: { pack_ids: packIds, user_id: user.id },
    });
    return res.data;
};

export const getMensageriaTotalNaoLidas = async () => {
    const res = await api.get('/mensageria/total-nao-lidas', {
        params: { user_id: user.id },
    });
    return res.data;
};

export const marcarMensagemNaoLida = async (packId) => {
    const res = await api.post('/mensageria/marcar-nao-lida', {
        pack_id: packId,
        user_id: user.id,
    });
    return res.data;
};

export const marcarTodasMensagensLidas = async () => {
    const res = await api.post('/mensageria/marcar-todas-lidas', { user_id: user.id });
    return res.data;
};

export const marcarTodasMensagensNaoLidas = async () => {
    const res = await api.post('/mensageria/marcar-todas-nao-lidas', { user_id: user.id });
    return res.data;
};

export const finalizarConversaMensageria = async (packId) => {
    const res = await api.post('/mensageria/finalizar', { pack_id: packId, user_id: user.id });
    return res.data;
};

export const reabrirConversaMensageria = async (packId) => {
    const res = await api.post('/mensageria/reabrir', { pack_id: packId, user_id: user.id });
    return res.data;
};

export const getMensageriaMetricas = async (dias = 30) => {
    const res = await api.get('/mensageria/metricas', { params: { dias } });
    return res.data;
};

export const getLogs = async (consulta) => {
    try {
        var res = await api.get(`/logs_api/${consulta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const getLogsEstoqueTaga = async (consulta) => {
    try {
        var res = await api.get(`/logs_estoque_taga/${consulta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const atualizarVendas = async () => {
    try {
        var res = await api.get(`/atualiza_vendas`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const getAnuncioML = async (id_ml, conta) => {
    try {
        var res = await api.get(`/anuncio_mercado_livre/${id_ml}/${conta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const getAnuncioMagalu = async (id_magalu) => {
    try {
        var res = await api.get(`/anuncio_magalu/${id_magalu}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const getAnuncioAmazon = async (id_amazon) => {
    try {
        var res = await api.get(`/anuncio_amazon/${id_amazon}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const getProdutoId = async (id) => {
    try {
        var res = await api.get(`/produto_taga/${id}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const putProdutoTAGA = async (data) => {
    try {
        const updatedData = {
            ...data,
            userId: user.id
        };
        const res = await api.put("/produto_taga", updatedData);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const putAnuncioML = async (data) => {
    try {
        const updatedData = {
            ...data,
            userId: user.id
        };
        const res = await api.put("/anuncio_mercado_livre", updatedData);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const setBloqueioProduto = async (id, status, motivo = null) => {
    try {
        const res = await api.put("/bloqueio_produto", { id, status, motivo, userId: user.id });
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch {
        return false;
    }
};

export const bulkSetBloqueioProduto = async (ids, status, motivo = null) => {
    try {
        const res = await api.post("/produtos/bulk-bloqueio", { ids, status, motivo, userId: user.id });
        if (res.status !== 200 || res.data.success === false) {
            return false;
        } else {
            return res.data;
        }
    } catch (error) {
        console.error("Erro ao executar ação em massa de bloqueio:", error);
        return false;
    }
};


export const getGraficoSemanal = async () => {
    try {
        var res = await api.get(`/grafico_vendas_semanal`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const getGraficoMensal = async () => {
    try {
        var res = await api.get(`/grafico_vendas_mensal`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const getDadosVendasDashboard = async () => {
    try {
        var res = await api.get(`/dados_vendas_dashboard`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const getProcessadorMonitoramentoResumo = async (dataInicio, dataFim, origem = null) => {
    try {
        const params = { data_inicio: dataInicio, data_fim: dataFim };
        if (origem) params.origem = origem;
        const res = await api.get("/processador/monitoramento/resumo", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar resumo do monitoramento:", error);
        return { error: error.response?.data?.error || error.message };
    }
};

export const getProcessadorMonitoramentoDia = async (data, tipo, origem = null) => {
    try {
        const params = { tipo };
        if (origem) params.origem = origem;
        const res = await api.get(`/processador/monitoramento/dia/${data}`, { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar detalhes do dia:", error);
        return { error: error.response?.data?.error || error.message };
    }
};

export const exportarProcessadorMonitoramento = async (dataInicio, dataFim, origem = null) => {
    try {
        const params = { data_inicio: dataInicio, data_fim: dataFim };
        if (origem) params.origem = origem;
        const res = await api.get("/processador/monitoramento/exportar", {
            params,
            responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `monitoramento_processador_${dataInicio}_a_${dataFim}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { success: true };
    } catch (error) {
        console.error("Erro ao exportar:", error);
        return { error: error.response?.data?.error || error.message };
    }
};

export const exportarRemuneracaoProcessador = async (dataInicio, dataFim) => {
    try {
        const params = { data_inicio: dataInicio, data_fim: dataFim };
        const res = await api.get("/processador/monitoramento/exportar-remuneracao", {
            params,
            responseType: 'blob'
        });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `remuneracao_processador_${dataInicio}_a_${dataFim}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { success: true };
    } catch (error) {
        console.error("Erro ao exportar remuneração:", error);
        return { error: error.response?.data?.error || error.message };
    }
};

export const getProcessadorMonitoramentoSemanal = async (dataInicio, dataFim) => {
    try {
        const params = { data_inicio: dataInicio, data_fim: dataFim };
        const res = await api.get("/processador/monitoramento/semanal", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar resumo semanal:", error);
        return { error: error.response?.data?.error || error.message };
    }
};

export const atualizarDataLimiteEnvio = async (idVenda, dataLimiteEnvio) => {
    try {
        const userString = window.localStorage.getItem("user");
        const user = JSON.parse(userString);
        const res = await api.put("/vendas/envio/data-limite-envio", {
            id: idVenda,
            data_limite_envio: dataLimiteEnvio,
            userId: user?.id,
        });
        return res.data;
    } catch (error) {
        console.error("Erro ao atualizar data limite de envio:", error);
        const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message || 'Erro desconhecido.';
        return { success: false, error: errorMsg };
    }
};

export const setMarcadorVenda = async (id, marcador) => {
    try {
        const res = await api.put("/marcador", { id, marcador, userId: user.id });
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch {
        return false;
    }
};



export const getAnunciosConcorrencia = async (consulta) => {
    try {
        var res = await api.get(`/anuncios_concorrente?${consulta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const emitirNfML = async (queryString, bodyData = {}) => {
    try {
        let consultaAux = queryString + "&user=" + user.id;
        var res = await api.post(`/emitir_nota_fiscal_ml?${consultaAux}`, bodyData);

        if (res.status !== 200 || (res.data && res.data.length === 0)) {
            return false;
        } else {
            return res.data;
        }
    } catch (error) {
        console.error("Erro na api:", error);
        return false;
    }
};


export const imprimirEtiquetaML = async (consulta) => {
    try {
        let consultaAux = consulta + "&user=" + user.id;
        const res = await api.get(`/imprimir_etiqueta?${consultaAux}`, {
            responseType: "arraybuffer",
        });

        const contentType = res.headers["content-type"];
        if (contentType.includes("application/json")) {
            try {
                const jsonString = new TextDecoder("utf-8").decode(res.data);
                const retornoJSON = JSON.parse(jsonString);

                if (Array.isArray(retornoJSON) && retornoJSON[0]?.status === false) {
                    return {
                        status: false,
                        error: {
                            message: "Erro na API",
                            details: retornoJSON[0].retorno?.message,
                        },
                    };
                }

                if (retornoJSON?.error) {
                    return {
                        status: false,
                        error: {
                            message: "Erro na API",
                            details: retornoJSON.error,
                        },
                    };
                }
            } catch (parseError) {
                return {
                    status: false,
                    error: {
                        message: "Erro ao processar resposta JSON",
                        details: parseError.message,
                    },
                };
            }
        }

        if (res.status !== 200 || res.data.byteLength === 0) {
            return { status: false, error: { message: "Arquivo vazio ou erro na API" } };
        }

        return {
            status: true,
            data: res.data, // Arquivo binário
            contentType: contentType, // Tipo do arquivo
        };
    } catch (error) {
        return {
            status: false,
            error: {
                message: "Erro na requisição",
                details: error.message,
            },
        };
    }
};



export const consultarRetornoProcessamento = async (consulta) => {
    try {
        var res = await api.get(`/retorno_processamento?${consulta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const getDadosReputacao = async () => {
    try {
        var res = await api.get(`/dados_reputacao_ml`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const getGraficoUltimos30 = async () => {
    try {
        var res = await api.get(`/grafico_vendas_ultimos_30`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


// Devolve true no sucesso, false em falha generica ou { erro } quando a API explica
// o motivo (ex.: comissao ja paga, canal de contato faltando).
export const setAtribuicaoVendaVendedor = async (id, status, userId = null, negociacao = null) => {
    try {
        const corpo = { id: id, status: status, userId: userId || user.id };
        if (negociacao) corpo.negociacao = negociacao;
        const res = await api.put("/vendas/vendedor", corpo);
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch (e) {
        const erro = e.response?.data?.error;
        return erro ? { erro } : false;
    }
};


export const gerarOrcamento = async (formData) => {
    try {
        const res = await api.post(`/download-orcamento`, formData, {
            responseType: 'blob',
        });

        if (res.status !== 200) {
            return false;
        }

        return res.data;
    } catch (error) {
        return false;
    }
};

export const getOrcamentos = async (params) => {
    try {
        const res = await api.get(`/orcamentos`, { params });
        if (res.status !== 200) {
            return false;
        }
        return res.data;
    } catch (error) {
        return false;
    }
};

export const baixarOrcamento = async (codigo) => {
    const blob = await gerarOrcamento({ codigo });
    if (!blob) {
        throw new Error('Não foi possível gerar o PDF do orçamento.');
    }
    return _triggerBlobDownload(blob, 'application/pdf', `orcamento_${codigo}.pdf`);
};


export const getAnunciosDenuncias = async () => {
    try {
        var res = await api.get(`/anuncios-denuncias`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const searchProdutosAutoComplete = async (consulta) => {
    try {
        var res = await api.get(`/produtos_search?busca=${consulta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const searchOrcamento = async (consulta) => {
    try {
        var res = await api.get(`/produtos_orcamento?codigo=${consulta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};


export const postVendaManual = async (json) => {
    try {
        const response = await api.post("/venda_manual", json);
        if (response.status === 201) {
            return { "status": true, "data": response.data };
        } else {
            return { "status": false, "data": response.data };
        }
    } catch (error) {
        console.error("Erro ao cadastrar venda:", error);
        return { "status": false, "data": {} };
    }
};


export const setStatusVenda = async (id, status) => {
    try {
        const res = await api.put("/vendas/status", { id, status, userId: user.id });
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch {
        return false;
    }
};

export const setLinkLalamove = async (vendaId, link) => {
    try {
        const res = await api.put(`/vendas/${vendaId}/link-lalamove`, { link, userId: user.id });
        return res.data;
    } catch (err) {
        return { error: err.response?.data?.error || 'Erro ao salvar link de rastreio' };
    }
};


export const getReclamacoes = async (params = {}) => {
    try {
        const qs = new URLSearchParams(params).toString();
        const res = await api.get(`/reclamacoes?${qs}`);
        return res.status === 200 ? res.data : null;
    } catch (err) {
        console.error("Erro ao buscar reclamações:", err);
        return null;
    }
};

export const getReclamacoesMetricas = async (params = {}) => {
    try {
        const qs = new URLSearchParams(params).toString();
        const res = await api.get(`/reclamacoes/metricas?${qs}`);
        return res.status === 200 ? res.data : null;
    } catch (err) {
        console.error("Erro ao buscar métricas de reclamações:", err);
        return null;
    }
};

export const getReclamacaoDetalhe = async (id) => {
    try {
        const res = await api.get(`/reclamacoes/${id}`);
        return res.status === 200 ? res.data : null;
    } catch (err) {
        console.error("Erro ao buscar detalhe da reclamação:", err);
        return null;
    }
};

export const getAnexoReclamacao = async (id, file) => {
    try {
        const res = await api.get(`/reclamacoes/${id}/anexo`, { params: { file }, responseType: 'blob' });
        return res.status === 200 ? res.data : null;
    } catch (err) {
        return null;
    }
};

export const refreshReclamacao = async (id) => {
    try {
        const res = await api.post(`/reclamacoes/${id}/refresh`);
        return res.data;
    } catch (err) {
        console.error("Erro ao atualizar reclamação:", err);
        return null;
    }
};

export const adicionarNotaReclamacao = async (id, payload) => {
    try {
        const res = await api.post(`/reclamacoes/${id}/nota`, payload);
        return res.data;
    } catch (err) {
        console.error("Erro ao adicionar nota:", err);
        return null;
    }
};

export const definirResponsavelReclamacao = async (id, payload) => {
    try {
        const res = await api.put(`/reclamacoes/${id}/responsavel`, payload);
        return res.data;
    } catch (err) {
        console.error("Erro ao definir responsável:", err);
        return null;
    }
};

export const responderMensagemReclamacao = async (id, payload) => {
    try {
        const res = await api.post(`/reclamacoes/${id}/mensagem`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { sucesso: false, erro: 'Falha ao enviar mensagem' };
    }
};

export const abrirDisputaReclamacao = async (id) => {
    try {
        const res = await api.post(`/reclamacoes/${id}/abrir-disputa`);
        return res.data;
    } catch (err) {
        return err.response?.data || { sucesso: false, erro: 'Falha ao abrir mediação' };
    }
};

export const reembolsoTotalReclamacao = async (id) => {
    try {
        const res = await api.post(`/reclamacoes/${id}/reembolso-total`);
        return res.data;
    } catch (err) {
        return err.response?.data || { sucesso: false, erro: 'Falha ao reembolsar' };
    }
};

export const ofertasParciaisReclamacao = async (id) => {
    try {
        const res = await api.get(`/reclamacoes/${id}/ofertas-parciais`);
        return res.data;
    } catch (err) {
        return null;
    }
};

export const reembolsoParcialReclamacao = async (id, payload) => {
    try {
        const res = await api.post(`/reclamacoes/${id}/reembolso-parcial`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { sucesso: false, erro: 'Falha ao reembolsar parcialmente' };
    }
};

export const oferecerDevolucaoReclamacao = async (id) => {
    try {
        const res = await api.post(`/reclamacoes/${id}/oferecer-devolucao`);
        return res.data;
    } catch (err) {
        return err.response?.data || { sucesso: false, erro: 'Falha ao oferecer devolução' };
    }
};

export const uploadAnexoReclamacao = async (id, formData) => {
    try {
        const res = await api.post(`/reclamacoes/${id}/anexo`, formData);
        return res.data;
    } catch (err) {
        return err.response?.data || { sucesso: false, erro: 'Falha no upload' };
    }
};

export const validarVendaParaReclamacaoManual = async (consulta, excluir) => {
    try {
        const qs = excluir ? `?excluir=${excluir}` : '';
        const res = await api.get(`/reclamacoes/validar-venda/${consulta}${qs}`);
        return res.data;
    } catch (err) {
        return err.response?.data || { elegivel: false, error: err.message };
    }
};

export const criarReclamacaoManual = async (payload) => {
    try {
        const res = await api.post('/reclamacoes/criar-manual', payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const atualizarReclamacaoManual = async (id, payload) => {
    try {
        const res = await api.patch(`/reclamacoes/${id}/manual`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const excluirReclamacaoManual = async (id) => {
    try {
        const res = await api.delete(`/reclamacoes/${id}/manual`);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const getDevolucoesML = async (consulta) => {
    try {
        var res = await api.get(`/devolucoes_ml?${consulta}`);
        if (res.status !== 200 || res.data.length === 0) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const getDevolucoesMetricas = async (params) => {
    try {
        const res = await api.get(`/devolucoes_metricas?${params}`);
        return res.status === 200 ? res.data : null;
    } catch {
        return null;
    }
};

export const exportDevolucoesMetricasCsv = async (params) => {
    const res = await api.get(`/devolucoes_metricas/export?${params}`, { responseType: 'blob' });
    return res.data;
};


export const setDevolucaoAvariaML = async (id, status) => {
    try {
        const res = await api.put("/devolucoes/avaria", { id: id, status: status, userId: user.id });
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch {
        return false;
    }
};

export const setDevolucaoRecebimentoML = async (id, status) => {
    try {
        const res = await api.put("/devolucoes/recebimento", { id: id, status: status, userId: user.id });
        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return true
        }
    } catch {
        return false;
    }
};

export const anexarArquivosDevolucao = async (id, files, pre_analise = '') => {
    try {
        console.log("=== INÍCIO anexarArquivosDevolucao ===");
        console.log("Parâmetros recebidos:", { id, files, pre_analise });

        const userString = window.localStorage.getItem("user");
        console.log("UserString do localStorage:", userString);

        if (!userString || userString === 'undefined') {
            throw new Error("Usuário não encontrado no localStorage");
        }

        const user = JSON.parse(userString);
        console.log("User parseado:", user);

        // Criar FormData para envio dos arquivos
        const formData = new FormData();
        formData.append("id", id.toString());
        formData.append("userId", user.id.toString());

        // Adicionar pré-análise se fornecida
        if (pre_analise && pre_analise.trim()) {
            formData.append("pre_analise", pre_analise.trim());
        }

        // Adicionar arquivos ao FormData (com índices para múltiplos arquivos)
        files.forEach((file, index) => {
            formData.append(`arquivos[]`, file);
        });

        // Log para debug - verificar FormData
        console.log("Enviando dados:", {
            id: id,
            userId: user.id,
            pre_analise: pre_analise,
            files_count: files.length
        });

        // Log detalhado do FormData
        console.log("FormData entries:");
        for (let [key, value] of formData.entries()) {
            if (value instanceof File) {
                console.log(`${key}:`, `File(${value.name}, ${value.size} bytes, ${value.type})`);
            } else {
                console.log(`${key}:`, value);
            }
        }

        console.log("=== ENVIANDO REQUISIÇÃO ===");
        console.log("URL:", api.defaults.baseURL + "/devolucoes/anexar-arquivos");
        console.log("Método: POST");
        console.log("FormData size:", formData.entries ? 'OK' : 'ERRO');

        const res = await api.post("/devolucoes/anexar-arquivos", formData);

        console.log("=== RESPOSTA RECEBIDA ===");
        console.log("Status:", res.status);
        console.log("Data:", res.data);

        if (res.status !== 200 || res.data === false) {
            return false;
        } else {
            return res.data;
        }
    } catch (error) {
        console.error("Erro ao anexar arquivos à devolução:", error);

        // Log detalhado do erro para debug
        if (error.response) {
            console.error("Dados da resposta de erro:", error.response.data);
            console.error("Status do erro:", error.response.status);
        }

        return false;
    }
};

export const dispararAnaliseIADevolucao = async (id) => {
    try {
        const userString = window.localStorage.getItem("user");
        const user = userString && userString !== 'undefined' ? JSON.parse(userString) : null;
        const res = await api.post("/devolucoes/analisar-ia", { id, userId: user?.id });
        if (res.status >= 200 && res.status < 300 && res.data?.success) {
            return res.data;
        }
        return false;
    } catch (error) {
        console.error("Erro ao disparar análise IA:", error);
        return { success: false, message: error.response?.data?.message || 'Erro ao enfileirar análise' };
    }
};

export const removerArquivoDevolucao = async (id, arquivo) => {
    try {
        const userString = window.localStorage.getItem("user");
        if (!userString || userString === 'undefined') {
            throw new Error("Usuário não encontrado");
        }
        const user = JSON.parse(userString);

        const res = await api.delete("/devolucoes/remover-arquivo", {
            data: { id, userId: user.id, arquivo },
        });

        if (res.status !== 200 || res.data?.success !== true) {
            return false;
        }
        return res.data;
    } catch (error) {
        console.error("Erro ao remover arquivo da devolução:", error);
        return false;
    }
};

export const criarCotacaoAutomatica = async (itens) => {
    try {
        const res = await api.post("/cotacoes", { itens });
        return res.data;
    } catch (err) {
        throw err;

    }
}

export const listarCotacoes = async () => {
    try {
        const res = await api.get("/cotacoes");
        return res.data;
    } catch (err) {
        console.error("Erro ao listar cotações", err);
        return [];
    }
};

export const buscarCotacaoPorToken = async (token) => {
    try {
        const res = await api.get(`/cotacoes/${token}`);
        return res.data;
    } catch (err) {
        throw err;
    }
};

export const enviarRespostasCotacao = async (body) => {
    try {
        const res = await api.post("/respostas", body);
        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getDetalheCotacao = async (token) => {
    try {
        const res = await api.get(`/cotacoes-detalhe/${token}`);
        return res.data;
    } catch (err) {
        throw err;
    }
}

export const getCotacoesStatusVendas = async (idsOrigem) => {
    try {
        if (!idsOrigem || idsOrigem.length === 0) return {};
        const res = await api.post('/vendas/cotacoes-status', { ids_origem: idsOrigem });
        return res.data || {};
    } catch (err) {
        console.error('Erro ao buscar status de cotações por vendas:', err);
        return {};
    }
};

export const marcarCompradoAqui = async (respostaItemId) => {
    const res = await api.post(`/respostas-itens/${respostaItemId}/comprado-aqui`);
    return res.data;
};

// Fornecedores que recebem o link da cotação por WhatsApp
export const listarFornecedoresCotacao = async () => {
    try {
        const res = await api.get('/cotacoes-fornecedores');
        return res.data;
    } catch (err) {
        console.error('Erro ao listar fornecedores de cotação:', err);
        return [];
    }
};

export const criarFornecedorCotacao = async (payload) => {
    try {
        const res = await api.post('/cotacoes-fornecedores', payload);
        return res.data;
    } catch (err) {
        console.error('Erro ao criar fornecedor de cotação:', err);
        return err.response?.data || false;
    }
};

export const atualizarFornecedorCotacao = async (id, payload) => {
    try {
        const res = await api.put(`/cotacoes-fornecedores/${id}`, payload);
        return res.data;
    } catch (err) {
        console.error('Erro ao atualizar fornecedor de cotação:', err);
        return err.response?.data || false;
    }
};

export const excluirFornecedorCotacao = async (id) => {
    try {
        const res = await api.delete(`/cotacoes-fornecedores/${id}`);
        return res.data;
    } catch (err) {
        console.error('Erro ao excluir fornecedor de cotação:', err);
        return err.response?.data || false;
    }
};

export const getNotificacoes = async (params = {}) => {
    try {
        const res = await api.get('/notificacoes', { params });
        return res.status === 200 ? res.data : false;
    } catch (error) {
        console.error("Erro ao buscar notificações:", error);
        return false;
    }
};


export const getNovasNotificacoesApi = async () => {
    try {
        const res = await api.get('/notificacoes/novas');
        return res.status === 200 ? res.data : false;
    } catch (error) {
        console.error("Erro ao buscar novas notificações da API:", error);
        return false;
    }
};




export const markNotificacaoAsRead = async (id) => {
    try {
        const res = await api.put('/notificacoes/marcar-lida', { id });
        return res.status === 200;
    } catch (error) {
        console.error("Erro ao marcar notificação como lida:", error);
        return false;
    }
};


export const markAllNotificacoesAsRead = async (ids) => {
    try {
        const res = await api.put('/notificacoes/marcar-todas-lidas', { ids });
        return res.status === 200;
    } catch (error) {
        console.error("Erro ao marcar todas notificações como lidas:", error);
        return false;
    }
};

export const markNotificacaoAsDisplayed = async (id) => {
    try {
        const res = await api.put('/notificacoes/marcar-exibida', { id });
        return res.status === 200;
    } catch (error) {
        console.error("Erro ao marcar notificação como exibida:", error);
        return false;
    }
};

export const markNotificacaoAsUnread = async (id) => {
    try {
        const res = await api.put('/notificacoes/marcar-nao-lida', { id });
        return res.status === 200;
    } catch (error) {
        console.error("Erro ao marcar notificação como NÃO lida:", error);
        return false;
    }
};


export const subscribeToPushNotifications = async (subscription) => {
    try {
        const res = await api.post('/push-subscriptions', subscription);
        return res.status === 201; // 201 Created
    } catch (error) {
        console.error("Erro ao inscrever para notificações push:", error.response?.data || error.message);
        return false;
    }
};

export const unsubscribeFromPushNotifications = async (subscription) => {
    try {
        const res = await api.delete('/push-subscriptions', {
            data: { endpoint: subscription.endpoint }
        });
        return res.status === 200;
    } catch (error) {
        console.error("Erro ao cancelar inscrição de notificações push:", error.response?.data || error.message);
        return false;
    }
};


export const getPedidosPorStatus = async (status, page, otherParams = {}) => {
    try {
        const res = await api.get('/vendas_status', {
            params: {
                status: status,
                page: page,
                ...otherParams
            }
        });
        return res.status === 200 ? res.data : false;
    } catch (error) {
        console.error("Erro ao buscar vendas por status:", error);
        return false;
    }
};


export const getCanceladasDespacho = async (params = {}) => {
    try {
        const res = await api.get('/despacho/canceladas', { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar canceladas:", error);
        return params.modo === 'busca' ? { vendas: [], busca_ampliada: false } : [];
    }
};

export const anteciparDespachoVenda = async (vendaId) => {
    try {
        const userString = window.localStorage.getItem("user");
        const user = JSON.parse(userString);
        const res = await api.post('/despacho/antecipar', { venda_id: vendaId, userId: user?.id });
        return res.data;
    } catch (error) {
        console.error("Erro ao antecipar despacho:", error);
        const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message || 'Erro desconhecido.';
        return { success: false, error: errorMsg };
    }
};

export const incluirCanceladaNoEstoque = async (payload) => {
    try {
        const res = await api.post('/despacho/canceladas/incluir-estoque', payload);
        return res.data;
    } catch (error) {
        return { error: error.response?.data?.error || 'Erro ao incluir no estoque' };
    }
};

export const darEntradaEstoqueProblema = async (payload) => {
    try {
        const res = await api.post('/despacho/problemas/dar-entrada-estoque', payload);
        return res.data;
    } catch (error) {
        return { error: error.response?.data?.error || 'Erro ao dar entrada no estoque' };
    }
};

export const corrigirImagemProduto = async (payload) => {
    try {
        const res = await api.post('/despacho/corrigir-imagem-produto', payload);
        return res.data;
    } catch (error) {
        return { error: error.response?.data?.error || 'Erro ao corrigir imagem' };
    }
};

export const editarImagem = async (imagemId, payload) => {
    try {
        const res = await api.post(`/imagens/${imagemId}/editar`, payload);
        return res.data;
    } catch (error) {
        return { error: mensagemDeErro(error.response?.data ?? error, 'Erro ao editar a imagem') };
    }
};

export const restaurarImagemOriginal = async (imagemId) => {
    try {
        const res = await api.post(`/imagens/${imagemId}/restaurar-original`);
        return res.data;
    } catch (error) {
        return { error: mensagemDeErro(error.response?.data ?? error, 'Erro ao restaurar a foto original') };
    }
};

export const previewSemFundoImagem = async ({ imagem_id, modelo = null }) => {
    try {
        const res = await api.post('/despacho/imagem/preview-sem-fundo', { imagem_id, modelo });
        return res.data;
    } catch (error) {
        return { error: mensagemDeErro(error.response?.data ?? error, 'Erro ao gerar a prévia sem fundo') };
    }
};

export const getImagensDivergentes = async () => {
    try {
        const res = await api.get('/despacho/imagens-divergentes');
        return Array.isArray(res.data) ? res.data : [];
    } catch (error) {
        console.error("Erro ao buscar imagens divergentes:", error);
        return [];
    }
};

export const marcarFuroEstoqueTaga = async (itemVendaId) => {
    try {
        const res = await api.post('/despacho/conferencia/furo-estoque-taga', { item_venda_id: itemVendaId });
        return res.data;
    } catch (error) {
        return { error: error.response?.data?.error || 'Erro ao marcar furo de estoque TAGA' };
    }
};

export const buscarProdutoEstoqueMobile = async (termo) => {
    try {
        const res = await api.get('/estoque-taga/buscar-mobile', { params: { termo } });
        return res.data;
    } catch (error) {
        return { error: error.response?.data?.error || 'Erro na busca' };
    }
};

export const entradaEstoqueMobile = async ({ produto_id, quantidade, localizacao }) => {
    try {
        const res = await api.post('/estoque-taga/entrada-mobile', { produto_id, quantidade, localizacao });
        return res.data;
    } catch (error) {
        return { error: error.response?.data?.error || 'Erro ao registrar entrada' };
    }
};

export const getProdutosParaConferencia = async () => {
    try {
        const res = await api.get('/despacho/produtos-para-conferencia');
        if (res.status === 200) {
            return res.data;
        }
        return [];
    } catch (error) {
        console.error("Erro ao buscar produtos para conferência:", error);
        return [];
    }
};


// Devolve o corpo da resposta (traz liberouRetirada/prontoRetiradaAt) ou null
// se falhou. O chamador só testa a verdade do retorno.
export const salvarConferenciaProduto = async (payload) => {
    try {
        const res = await api.post('/despacho/salvar-conferencia', payload);
        return res.status === 200 ? (res.data || {}) : null;
    } catch (error) {
        console.error("Erro ao salvar conferência:", error.response?.data || error.message);
        return null;
    }
};


export const getDetalhesConferencia = async (vendaId, produtoEstoqueId) => {
    try {
        const res = await api.get(`/despacho/conferencia-detalhes/${vendaId}/${produtoEstoqueId}`);
        return res.status === 200 ? res.data : null;
    } catch (error) {
        console.error("Erro ao buscar detalhes da conferência:", error);
        return null;
    }
};


export const reverterConferenciaProduto = async (vendaId, produtoEstoqueId) => {
    try {
        const res = await api.post('/despacho/reverter-conferencia', { vendaId, produtoEstoqueId });
        return res.status === 200;
    } catch (error) {
        console.error("Erro ao reverter conferência:", error.response?.data || error.message);
        return false;
    }
};

export const concluirEmbalagemDespacho = async (vendaIds) => {
    const id = Array.isArray(vendaIds) ? vendaIds.join(',') : vendaIds;
    try {
        const res = await api.post("/despacho/concluir-embalagem", { id, user: user.id });
        return res.data;
    } catch (error) {
        console.error("Erro ao concluir embalagem:", error);
        return false;
    }
};

export const reverterEmbalagemDespacho = async (vendaIds) => {
    const id = Array.isArray(vendaIds) ? vendaIds.join(',') : vendaIds;
    try {
        const res = await api.post("/despacho/reverter-embalagem", { id, user: user.id });
        return res.data;
    } catch (error) {
        console.error("Erro ao reverter embalagem:", error);
        return false;
    }
};

/**
 * Libera (pronto=true) ou desfaz (pronto=false) a retirada na loja de uma venda
 * do site. O cliente só é avisado 5 minutos depois, então desmarcar dentro da
 * janela cancela o e-mail e o WhatsApp.
 */
export const marcarProntoRetiradaDespacho = async (vendaId, pronto = true) => {
    try {
        const res = await api.post("/despacho/pronto-retirada", { id: vendaId, pronto, userId: user.id });
        return { ok: true, ...res.data };
    } catch (error) {
        console.error("Erro ao marcar pronto para retirada:", error);
        return { ok: false, error: error?.response?.data?.error || "Falha ao falar com o servidor." };
    }
};

/**
 * Cliente retirou a peça no balcão: conclui a venda e dispara o aviso de
 * pedido entregue. Não tem volta pela tela do despacho.
 */
export const marcarRetiradaColetadaDespacho = async (vendaId) => {
    try {
        const res = await api.post("/despacho/retirada-coletada", { id: vendaId, userId: user.id });
        return { ok: true, ...res.data };
    } catch (error) {
        console.error("Erro ao concluir retirada:", error);
        return { ok: false, error: error?.response?.data?.error || "Falha ao falar com o servidor." };
    }
};

/**
 * Confere no Melhor Envio se o saldo cobre o valor informado somado às etiquetas
 * pendentes (no carrinho) das vendas indicadas.
 * Retorna { suficiente, saldo, necessario, mensagem } ou null se a consulta falhar.
 */
export const verificarSaldoMelhorEnvio = async (valor = 0, vendaIds = []) => {
    try {
        const res = await api.post("/melhor-envio/verificar-saldo", { valor, venda_ids: vendaIds });
        return res.data;
    } catch (error) {
        console.error("Erro ao verificar saldo do Melhor Envio:", error);
        return null;
    }
};

export const processarExpedicaoVenda = async (vendaId, tipoAcao, user, overrideData = null, modalidadeFrete = null, opcoes = {}) => {
    try {
        const payload = { id: vendaId, tipo_acao: tipoAcao, user };
        if (overrideData) {
            payload.override_data = overrideData;
        }
        // "0" = CIF (TAGA envia) / "1" = FOB (cliente busca). Sem isso vale o padrao do backend.
        if (modalidadeFrete) {
            payload.modalidade_frete = modalidadeFrete;
        }
        // Emissor das vendas do ML ("interno" | "mercado_livre"); sem ele vale o padrao de cada conta.
        if (opcoes.emissor === 'interno' || opcoes.emissor === 'mercado_livre') {
            payload.emissor = opcoes.emissor;
        }
        const res = await api.post("/despacho/processar-venda", payload);
        return res.data;
    } catch (error) {
        console.error("Erro ao processar expedição:", error);
        const httpStatus = error.response?.status;
        const detalhe = mensagemDeErro(error.response?.data ?? error, 'Erro desconhecido ao processar.');
        const errorMsg = httpStatus ? `HTTP ${httpStatus}: ${detalhe}` : detalhe;
        return { status: false, error: errorMsg };
    }
};

export const marcarEnvioExterno = async (vendaId, user, motivo = '') => {
    try {
        const res = await api.post("/despacho/marcar-envio-externo", { id: vendaId, user, motivo });
        return res.data;
    } catch (error) {
        console.error("Erro ao marcar envio externo:", error);
        const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message || 'Erro desconhecido.';
        return { success: false, error: errorMsg };
    }
};

export const desmarcarEnvioExterno = async (vendaId, user) => {
    try {
        const res = await api.post("/despacho/desmarcar-envio-externo", { id: vendaId, user });
        return res.data;
    } catch (error) {
        console.error("Erro ao desmarcar envio externo:", error);
        const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message || 'Erro desconhecido.';
        return { success: false, error: errorMsg };
    }
};

/**
 * Abre ou baixa um arquivo protegido (PDF/ZPL) via GET (com token).
 * Para downloads em lote usar downloadEtiquetasLote (POST).
 */

export const downloadArquivoProtegido = async (url, fileName = "arquivo.pdf") => {
    try {
        const response = await api.get(url, { responseType: 'blob' });
        const contentType = response.headers['content-type'] || '';

        // Se o backend retornou JSON (geralmente erro), precisamos ler o blob como texto
        if (contentType.includes('application/json')) {
            const text = await response.data.text();
            try {
                const json = JSON.parse(text);
                console.error('Erro na API (downloadArquivoProtegido):', json);
                return {
                    error: json.error || json.message || 'Erro desconhecido.',
                    detalhes: Array.isArray(json.detalhes) ? json.detalhes : []
                };
            } catch {
                return { error: 'Erro desconhecido na API.', detalhes: [] };
            }
        }

        _triggerBlobDownload(response.data, contentType, fileName);
        return { sucesso: true, avisos: lerAvisosDoCabecalho(response.headers) };
    } catch (error) {
        console.error('Erro no download protegido:', error);
        if (error.response?.data instanceof Blob) {
            try {
                const texto = await error.response.data.text();
                const json = JSON.parse(texto);
                return {
                    error: json.error || json.message || 'Falha ao baixar arquivo.',
                    detalhes: Array.isArray(json.detalhes) ? json.detalhes : []
                };
            } catch { /* ignorar */ }
        }
        return { error: error.response?.data?.message || 'Falha ao baixar arquivo.', detalhes: [] };
    }
};

/**
 * Download de etiquetas em LOTE via POST (suporta mix ML + Melhor Envio).
 * @param {number[]} vendaIds  - Array de IDs das vendas
 * @param {'pdf'|'zpl2'} tipo - Tipo do arquivo
 * @param {string} fileName   - Nome sugerido para o arquivo
 * @param {{ incluirDanfe?: boolean }} opts - Opcionais
 */
export const downloadEtiquetasLote = async (vendaIds, tipo = 'pdf', fileName = null, opts = {}) => {
    const ids = Array.isArray(vendaIds) ? vendaIds : [vendaIds];
    if (ids.length === 0) return { error: 'Nenhum ID informado.' };

    const incluirDanfe = !!opts.incluirDanfe;
    const token = window.localStorage.getItem('token');
    const nomeArquivo = fileName || (ids.length === 1
        ? `etiqueta_${ids[0]}.${tipo === 'pdf' && !incluirDanfe ? 'pdf' : 'zip'}`
        : `etiquetas_lote_${ids.length}.zip`);

    try {
        const response = await api.post(
            '/despacho/imprimir-etiquetas',
            { ids, tipo, incluir_danfe: incluirDanfe },
            { responseType: 'blob', headers: { Authorization: `Bearer ${token}` } }
        );

        const contentType = response.headers['content-type'] || '';

        // Verificar se retornou erro JSON dentro do blob
        if (contentType.includes('application/json')) {
            const text = await response.data.text();
            try {
                const json = JSON.parse(text);
                console.error('Erro na API (downloadEtiquetasLote):', json);
                return {
                    error: json.error || json.message || 'Nenhuma etiqueta encontrada.',
                    detalhes: Array.isArray(json.detalhes) ? json.detalhes : []
                };
            } catch {
                return { error: 'Erro desconhecido na API.' };
            }
        }

        // Derivar extensão real pelo content-type da resposta (mais confiável que o nome sugerido)
        let realFileName = nomeArquivo;
        if (contentType.includes('zip') && !realFileName.endsWith('.zip')) {
            realFileName = realFileName.replace(/\.\w+$/, '') + '.zip';
        } else if (contentType.includes('pdf') && !realFileName.endsWith('.pdf')) {
            realFileName = realFileName.replace(/\.\w+$/, '') + '.pdf';
        }

        _triggerBlobDownload(response.data, contentType, realFileName);
        return { sucesso: true, avisos: lerAvisosDoCabecalho(response.headers) };
    } catch (error) {
        // Tentar extrair erro do blob de resposta
        if (error.response?.data instanceof Blob) {
            try {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                console.error('Erro API etiquetas lote:', json);
                return {
                    error: json.error || json.message || 'Erro ao gerar etiquetas.',
                    detalhes: Array.isArray(json.detalhes) ? json.detalhes : []
                };
            } catch { /* ignorar */ }
        }
        console.error('Erro ao baixar etiquetas em lote:', error);
        return { error: error.response?.data?.message || 'Falha ao baixar etiquetas.', detalhes: [] };
    }
};

/**
 * Helper interno: aciona o download de um Blob no navegador.
 * Para PDFs, abre em nova aba. Para outros formatos, força download.
 */
const _triggerBlobDownload = (blobData, contentType, fileName) => {
    let blob;
    if (blobData instanceof Blob) {
        blob = blobData;
    } else if (typeof blobData === 'string' || blobData instanceof ArrayBuffer || ArrayBuffer.isView(blobData)) {
        blob = new Blob([blobData], { type: contentType || 'application/octet-stream' });
    } else {
        console.error('[_triggerBlobDownload] resposta inesperada do servidor', { tipo: typeof blobData, valor: blobData });
        throw new Error('Resposta do servidor não pôde ser convertida em arquivo.');
    }
    const objectUrl = window.URL.createObjectURL(blob);
    if ((contentType || '').includes('pdf')) {
        window.open(objectUrl, '_blank');
    } else {
        const link = document.createElement('a');
        link.href = objectUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    setTimeout(() => window.URL.revokeObjectURL(objectUrl), 30000);
    return true;
};


export const getZPLConteudo = async (vendaId, opts = {}) => {
    try {
        const danfeQs = opts.incluirDanfe ? '&incluir_danfe=1' : '';
        const res = await api.get(`/despacho/zpl-conteudo?id=${vendaId}${danfeQs}`);
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar ZPL:", error);
        return { status: false, error: error.message };
    }
};

/**
 * Obtém conteúdo ZPL em lote via POST (mais robusto para muitos IDs).
 * Suporta mix de origens (ML + Melhor Envio).
 * Retorna: { zpl: string, avisos?: string[] } | { error: string }
 */
export const getZPLConteudoMassa = async (vendaIds, opts = {}) => {
    const ids = Array.isArray(vendaIds) ? vendaIds : (vendaIds ? [vendaIds] : []);
    if (ids.length === 0) return { error: 'Nenhum ID informado.' };
    try {
        const res = await api.post('/despacho/zpl-conteudo', { ids, incluir_danfe: !!opts.incluirDanfe });
        return res.data;
    } catch (error) {
        console.error('Erro ao buscar ZPL em massa:', error);
        return {
            error: error.response?.data?.error || error.message || 'Erro ao obter ZPL.',
            detalhes: Array.isArray(error.response?.data?.detalhes) ? error.response.data.detalhes : []
        };
    }
};

export const getDanfeZplConteudo = async (vendaIds) => {
    const ids = Array.isArray(vendaIds) ? vendaIds : (vendaIds ? [vendaIds] : []);
    if (ids.length === 0) return { error: 'Nenhum ID informado.' };
    try {
        const res = await api.post('/despacho/danfe-zpl', { ids });
        return res.data;
    } catch (error) {
        console.error('Erro ao gerar DANFE ZPL:', error);
        return {
            error: error.response?.data?.error || error.message || 'Erro ao gerar DANFE ZPL.',
            detalhes: error.response?.data?.detalhes || []
        };
    }
};

export const downloadDanfePdf = async (vendaIds) => {
    const ids = Array.isArray(vendaIds) ? vendaIds : (vendaIds ? [vendaIds] : []);
    if (ids.length === 0) return { error: 'Nenhum ID informado.' };

    const token = window.localStorage.getItem('token');
    const nomeArquivo = ids.length === 1 ? `danfe_${ids[0]}.pdf` : `danfe_lote_${ids.length}.pdf`;

    try {
        const response = await api.post(
            '/despacho/danfe-pdf',
            { ids },
            { responseType: 'blob', headers: { Authorization: `Bearer ${token}` } }
        );

        const contentType = response.headers['content-type'] || '';

        if (contentType.includes('application/json')) {
            const text = await response.data.text();
            try {
                const json = JSON.parse(text);
                return { error: json.error || 'Falha ao gerar DANFE PDF.', detalhes: json.detalhes || [] };
            } catch {
                return { error: 'Resposta inválida do servidor.' };
            }
        }

        return _triggerBlobDownload(response.data, contentType, nomeArquivo);
    } catch (error) {
        if (error.response?.data instanceof Blob) {
            try {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                return { error: json.error || 'Erro ao gerar DANFE.', detalhes: json.detalhes || [] };
            } catch { /* ignorar */ }
        }
        console.error('Erro download DANFE PDF:', error);
        return { error: error.response?.data?.error || error.message || 'Falha ao baixar DANFE.' };
    }
};

export const downloadDanfeZpl = async (vendaIds) => {
    const ids = Array.isArray(vendaIds) ? vendaIds : (vendaIds ? [vendaIds] : []);
    if (ids.length === 0) return { error: 'Nenhum ID informado.' };

    const token = window.localStorage.getItem('token');
    const nomeArquivo = ids.length === 1 ? `danfe_${ids[0]}.zpl` : `danfe_lote_${ids.length}.zpl`;

    try {
        const response = await api.post(
            '/despacho/danfe-zpl-download',
            { ids },
            { responseType: 'blob', headers: { Authorization: `Bearer ${token}` } }
        );

        const contentType = response.headers['content-type'] || '';

        if (contentType.includes('application/json')) {
            const text = await response.data.text();
            try {
                const json = JSON.parse(text);
                return { error: json.error || 'Falha ao gerar DANFE ZPL.', detalhes: json.detalhes || [] };
            } catch {
                return { error: 'Resposta inválida do servidor.' };
            }
        }

        return _triggerBlobDownload(response.data, 'text/plain', nomeArquivo);
    } catch (error) {
        if (error.response?.data instanceof Blob) {
            try {
                const text = await error.response.data.text();
                const json = JSON.parse(text);
                return { error: json.error || 'Erro ao gerar DANFE.', detalhes: json.detalhes || [] };
            } catch { /* ignorar */ }
        }
        console.error('Erro download DANFE ZPL:', error);
        return { error: error.response?.data?.error || error.message || 'Falha ao baixar DANFE.' };
    }
};


export const getInfoAnuncioMLModal = async (produto_id, conta) => {
    try {
        const res = await api.get('/produto_modal_ml', {
            params: {
                produto_id: produto_id,
                conta: conta,
            }
        });
        return res.status === 200 ? res.data : false;
    } catch (error) {
        console.error("Erro ao buscar vendas por status:", error);
        return false;
    }
};




export const getTickets = (params) => {
    return api.get('/tickets', { params });
};

export const getTicket = (ticketId) => {
    return api.get(`/tickets/${ticketId}`);
};

export const getTicketMasterData = () => {
    return api.get('/master-data/tickets');
};

export const createTicket = (data) => {
    return api.post('/tickets', data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const createTicketCategory = (nome) => {
    return api.post('/ticket-categorias', { nome });
};

export const toggleCommentReaction = (commentId, emoji) => {
    return api.post(`/comentarios/${commentId}/reacoes`, { emoji });
};

export const updateTicket = (ticketId, data) => {
    data.append('_method', 'PUT');
    return api.post(`/tickets/${ticketId}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const addCommentToTicket = (ticketId, data) => {
    if (data instanceof FormData) {
        return api.post(`/tickets/${ticketId}/comentarios`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
    return api.post(`/tickets/${ticketId}/comentarios`, data);
};

export const deleteTicket = (ticketId) => {
    return api.delete(`/tickets/${ticketId}`);
};

export const reorderTickets = (items) => {
    return api.post('/tickets/reorder', { items });
};

export const downloadTicketAttachment = (attachmentId) => {
    return api.get(`/tickets/anexos/${attachmentId}/download`, {
        responseType: 'blob',
    });
};

export const deleteTicketComment = (commentId) => {
    return api.delete(`/comentarios/${commentId}`);
};

export const notifyTicket = (ticketId, data) => {
    return api.post(`/tickets/${ticketId}/notify`, data);
};

export const downloadCommentAttachment = (attachmentId) => {
    return api.get(`/comentarios/anexos/${attachmentId}/download`, {
        responseType: 'blob',
    });
};


export const exportVendasDiaria = async () => {
    try {
        const res = await api.get(`/vendas_exportar_diaria`, {
            responseType: 'blob',
        });

        if (res.status !== 200) {
            return false;
        }
        return res.data;
    } catch (error) {
        console.error("Erro ao baixar o relatório diário:", error);
        return false;
    }
};

export const exportVendasMensal = async () => {
    try {
        const res = await api.get(`/vendas_exportar_mensal`, {
            responseType: 'blob',
        });

        if (res.status !== 200) {
            return false;
        }
        return res.data;
    } catch (error) {
        console.error("Erro ao baixar o relatório mensal:", error);
        return false;
    }
};


export const getMetricasVendedor = async (userId) => {
    if (!userId) return false;
    try {
        const res = await api.get(`/vendas/metricas/vendedor/${userId}`);
        if (res.status !== 200) {
            return false;
        } else {
            return res.data;
        }
    } catch {
        return false;
    }
};

export const exportarMetricasVendedor = async (userId, dataInicio, dataFim) => {
    try {
        const response = await api.get('/vendas/exportar/vendedor', {
            params: {
                userId,
                data_inicio: dataInicio,
                data_fim: dataFim,
            },
            responseType: 'blob',
        });
        return response;
    } catch (error) {
        console.error("Erro ao exportar relatório:", error);
        return false;
    }
};

export const getIntegracoes = async (estoqueIds) => {
    if (!estoqueIds || !estoqueIds.ids || estoqueIds.ids.length === 0) {
        return {};
    }
    try {
        const res = await api.post('/produtos/integracoes', estoqueIds);
        if (res.status !== 200) {
            return {};
        }
        return res.data;
    } catch {
        return {};
    }
};

export const getLinkEcommerceProduto = async (produtoId) => {
    const res = await api.get(`/produtos/${produtoId}/link-ecommerce`);
    return res.data?.url || null;
};

export const getResumoComissoesVendedor = async (userId, dataInicio, dataFim) => {
    if (!userId) return false;
    try {
        const res = await api.get('/comissoes/vendedor/resumo', {
            params: {
                userId,
                data_inicio: dataInicio,
                data_fim: dataFim,
            },
        });
        return res.status === 200 ? res.data : false;
    } catch {
        return false;
    }
};

export const salvarComissaoVenda = async (payload) => {
    try {
        const res = await api.post('/comissoes/vendedor/venda', payload);
        return res.status === 200 ? res.data : false;
    } catch {
        return false;
    }
};

export const sincronizarComissoesParceiros = async ({ dias = 60, referral } = {}) => {
    try {
        const params = { dias };
        if (referral) params.referral = referral;
        const res = await api.post('/comissoes/vendedor/sincronizar-parceiros', null, { params });
        return res.status === 200 ? res.data : false;
    } catch {
        return false;
    }
};

// Negociacao da venda (#1517) e pagamento das comissoes (#1518). Lancam o erro do
// axios: quem chama mostra e.response?.data?.error.
export const getNegociacoesVendas = async (ids) => {
    const res = await api.get('/comissoes/vendedor/negociacoes', { params: { ids: ids.join(',') } });
    return res.data;
};

export const salvarNegociacaoVenda = async (vendaId, negociacao) => {
    const res = await api.put(`/comissoes/vendedor/negociacoes/${vendaId}`, { negociacao });
    return res.data;
};

export const getPagamentosComissao = async (userId) => {
    const res = await api.get('/comissoes/pagamentos', { params: { userId } });
    return res.data;
};

export const registrarPagamentoComissao = async (payload) => {
    const res = await api.post('/comissoes/pagamentos/fechamentos', payload);
    return res.data;
};

export const desfazerPagamentoComissao = async (fechamentoId, motivo) => {
    const res = await api.post(`/comissoes/pagamentos/fechamentos/${fechamentoId}/desfazer`, { motivo });
    return res.data;
};

export const desfazerItemPagamentoComissao = async (itemId, motivo) => {
    const res = await api.post(`/comissoes/pagamentos/itens/${itemId}/desfazer`, { motivo });
    return res.data;
};

export const reenviarPagamentoComissaoSite = async (fechamentoId) => {
    const res = await api.post(`/comissoes/pagamentos/fechamentos/${fechamentoId}/reenviar-site`);
    return res.data;
};

export const alterarRastreioComissao = async (payload) => {
    const res = await api.post('/comissoes/pagamentos/rastreio', payload);
    return res.data;
};

export const getFechamentosComissao = async (userId, filtros = {}) => {
    const res = await api.get('/comissoes/pagamentos/fechamentos', { params: { userId, ...filtros } });
    return res.data;
};

export const getEventosComissao = async (userId, filtros = {}) => {
    const res = await api.get('/comissoes/pagamentos/eventos', { params: { userId, ...filtros } });
    return res.data;
};

// Baixa a planilha (Competencias, Vendas, Pagamentos). Em erro a API manda JSON
// dentro do blob: le e devolve a mensagem.
export const exportarRelatorioComissao = async (userId, de, ate) => {
    try {
        const res = await api.get('/comissoes/pagamentos/exportar', { params: { userId, de, ate }, responseType: 'blob' });
        return { blob: res.data, nome: (res.headers?.['content-disposition'] || '').match(/filename="?([^";]+)"?/)?.[1] };
    } catch (e) {
        let erro = 'Não foi possível gerar o relatório.';
        try {
            erro = JSON.parse(await e.response.data.text()).error || erro;
        } catch {
            // resposta sem JSON: fica a mensagem padrao
        }
        return { erro };
    }
};

// ========== FUNÇÕES DE PROSPECÇÃO ==========

export const getProspectLists = async (page = 1) => {
    try {
        const res = await api.get(`/prospect-lists?page=${page}`);
        return res.status === 200 ? res.data : false;
    } catch (error) {
        console.error("Erro ao buscar listas de prospecção:", error);
        return false;
    }
};

export const createProspectList = async (data) => {
    try {
        const res = await api.post('/prospect-lists', data);
        return res.status === 201 ? res.data : false;
    } catch (error) {
        if (error.response?.status === 422) {
            return { error: error.response.data.error || error.response.data.errors };
        }
        console.error("Erro ao criar lista de prospecção:", error);
        return false;
    }
};

export const getProspectListById = async (id) => {
    try {
        const res = await api.get(`/prospect-lists/${id}`);
        return res.status === 200 ? res.data : false;
    } catch (error) {
        console.error("Erro ao buscar lista de prospecção:", error);
        return false;
    }
};

export const getProspectListStatistics = async (id) => {
    try {
        const res = await api.get(`/prospect-lists/${id}/statistics`);
        return res.status === 200 ? res.data : false;
    } catch (error) {
        console.error("Erro ao buscar estatísticas:", error);
        return false;
    }
};

export const updateProspectPlace = async (listId, placeId, data) => {
    try {
        const res = await api.put(`/prospect-lists/${listId}/places/${placeId}`, data);
        return res.status === 200 ? res.data : false;
    } catch (error) {
        if (error.response?.status === 422) {
            const errorMsg = error.response.data.error ||
                (typeof error.response.data.errors === 'string' ? error.response.data.errors :
                    typeof error.response.data.errors === 'object' ? JSON.stringify(error.response.data.errors) :
                        "Erro de validação");
            return { error: errorMsg };
        }
        console.error("Erro ao atualizar lugar:", error);
        return false;
    }
};

export const getPlacesNeedingReturn = async () => {
    try {
        const res = await api.get('/prospect-lists/places-needing-return');
        return res.status === 200 ? res.data : [];
    } catch (error) {
        console.error("Erro ao buscar lugares que precisam retorno:", error);
        return [];
    }
};

export const deleteProspectList = async (id) => {
    try {
        const res = await api.delete(`/prospect-lists/${id}`);
        return res.status === 200;
    } catch (error) {
        console.error("Erro ao excluir lista:", error);
        return false;
    }
};


export const getConfiguracoes = async () => {
    try {
        const res = await api.get('/configuracoes');
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao buscar configurações:", error);
        return null;
    }
};

export const updateConfiguracoes = async (configuracoes) => {
    try {
        const res = await api.put('/configuracoes', { configuracoes });
        return res.data;
    } catch (error) {
        console.error("Erro ao atualizar configurações:", error);
        throw error;
    }
};

export const getPrecoCalculado = async (custo, anuncio = "") => {
    try {
        const res = await api.get(`/produtos/calcular_preco`, { params: { custo, anuncio: anuncio || undefined } });
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao calcular preço:", error);
        return null;
    }
};

export const getPrecoCalculadoEcommerce = async (custo) => {
    try {
        const res = await api.get(`/produtos/calcular_preco_ecommerce?custo=${custo}`);
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao calcular preço e-commerce:", error);
        return null;
    }
};

export const getMargensFornecedores = async () => {
    try {
        const res = await api.get('/margens/fornecedores');
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao buscar margens dos fornecedores:", error);
        return null;
    }
};

export const updateMargensFornecedores = async (margens) => {
    try {
        const res = await api.put('/margens/fornecedores', { margens });
        return res.data;
    } catch (error) {
        console.error("Erro ao atualizar margens dos fornecedores:", error);
        throw error;
    }
};

// Margem própria por conta do ML (vazia = a conta segue marca > fornecedor > global).
export const getMargensContasMl = async () => {
    try {
        const res = await api.get('/margens/contas-ml');
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao buscar margens das contas do ML:", error);
        return null;
    }
};

export const updateMargensContasMl = async (margens) => {
    try {
        const res = await api.put('/margens/contas-ml', { margens });
        return res.data;
    } catch (error) {
        console.error("Erro ao atualizar margens das contas do ML:", error);
        throw error;
    }
};

export const getMargensMarcas = async () => {
    try {
        const res = await api.get('/margens/marcas');
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao buscar margens das marcas:", error);
        return null;
    }
};

export const saveMargemMarca = async (nome_fabricante, margem_contribuicao_alvo) => {
    try {
        const res = await api.post('/margens/marcas', { nome_fabricante, margem_contribuicao_alvo });
        return res.data;
    } catch (error) {
        console.error("Erro ao salvar margem da marca:", error);
        throw error;
    }
};

export const deleteMargemMarca = async (id) => {
    try {
        const res = await api.delete(`/margens/marcas/${id}`);
        return res.status === 200;
    } catch (error) {
        console.error("Erro ao remover margem da marca:", error);
        return false;
    }
};

export const getSugestoesMarcas = async (q = '') => {
    try {
        const res = await api.get(`/margens/marcas/sugestoes`, { params: { q } });
        if (res.status === 200) {
            return res.data;
        }
        return [];
    } catch (error) {
        console.error("Erro ao buscar sugestões de marcas:", error);
        return [];
    }
};

export const getExpedicaoFornecedores = async () => {
    try {
        const res = await api.get('/expedicao-ml/fornecedores');
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao buscar dias de expedição dos fornecedores:", error);
        return null;
    }
};

export const updateExpedicaoFornecedores = async (fornecedores) => {
    try {
        const res = await api.put('/expedicao-ml/fornecedores', { fornecedores });
        return res.data;
    } catch (error) {
        console.error("Erro ao atualizar dias de expedição dos fornecedores:", error);
        throw error;
    }
};

export const getExpedicaoAtualizacoes = async () => {
    try {
        const res = await api.get('/expedicao-ml/atualizacoes');
        if (res.status === 200) {
            return res.data;
        }
        return null;
    } catch (error) {
        console.error("Erro ao buscar atualizações de expedição:", error);
        return null;
    }
};

export const cancelarExpedicaoAtualizacao = async (id) => {
    try {
        const res = await api.put(`/expedicao-ml/atualizacoes/${id}/cancelar`);
        return res.data;
    } catch (error) {
        console.error("Erro ao cancelar atualização de expedição:", error);
        throw error;
    }
};

const getPrefix = (supplier) => {
    if (supplier === 'vannucci') return '/produtos-vannucci';
    if (supplier === 'brcompany') return '/produtos-brcompany';
    if (supplier === 'lng') return '/produtos-lng';
    if (supplier === 'cba') return '/produtos-cba';
    if (supplier === 'msam') return '/produtos-msam';
    if (supplier === 'blparts') return '/produtos-blparts';
    return '/produtos';
};

export const getSincronizacaoStatus = async (supplier = 'morelate') => {
    try {
        const prefix = getPrefix(supplier);
        const response = await api.get(`${prefix}/status-atualizacao`);
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar status da sincronização:", error);
        return null;
    }
};

export const prepararAtualizacao = async (supplier = 'morelate') => {
    const prefix = getPrefix(supplier);
    return api.post(`${prefix}/preparar-atualizacao`);
};

export const executarAtualizacao = async (supplier = 'morelate') => {
    const prefix = getPrefix(supplier);
    return api.post(`${prefix}/executar-atualizacao`);
};

export const pararAtualizacao = async (supplier = 'morelate') => {
    const prefix = getPrefix(supplier);
    return api.post(`${prefix}/parar-atualizacao`);
};

export const getSincronizacaoLogs = async (params, supplier = 'morelate') => {
    try {
        let url = "/logs/sincronizacao";
        if (supplier === 'vannucci') {
            url = "/produtos-vannucci/logs";
        } else if (supplier === 'brcompany') {
            url = "/produtos-brcompany/logs";
        } else if (supplier === 'lng') {
            url = "/produtos-lng/logs";
        } else if (supplier === 'cba') {
            url = "/produtos-cba/logs";
        } else if (supplier === 'msam') {
            url = "/produtos-msam/logs";
        } else if (supplier === 'blparts') {
            url = "/produtos-blparts/logs";
        }
        const response = await api.get(url, { params });
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar logs de sincronização:", error);
        return null;
    }
};

export const solicitarExportacaoRevisao = async (supplier = 'morelate') => {
    const prefix = getPrefix(supplier);
    const response = await api.post(`${prefix}/exportar-revisao`);
    return response.data;
};

export const solicitarExportacaoResultado = async (supplier = 'morelate') => {
    const prefix = getPrefix(supplier);
    const response = await api.post(`${prefix}/exportar-resultado`);
    return response.data;
};

export const baixarArquivoExportado = async (tipo, supplier = 'morelate') => {
    try {
        const prefix = getPrefix(supplier);
        const response = await api.get(`${prefix}/baixar-exportacao/${tipo}`, {
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        const date = new Date().toISOString().slice(0, 19).replace('T', '_').replace(/:/g, '-');
        const fileName = `${supplier}_${tipo}_atualizacao_${date}.xlsx`;

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error(`Erro ao baixar o arquivo de ${tipo}:`, error);
        const errorMessage = await error.response?.data?.text();
        const errorJson = errorMessage ? JSON.parse(errorMessage) : null;
        throw new Error(errorJson?.mensagem || `Não foi possível fazer o download do arquivo de ${tipo}.`);
    }
};

export const getUsers = async () => {
    try {
        const response = await api.get("/users");
        return response.data;
    } catch (error) {
        console.error("Erro ao buscar usuários:", error);
        return [];
    }
}

export const getTicketDashboardStats = async () => {
    const response = await api.get('/tickets/dashboard-stats');
    return response.data.data;
};


export const startProductExport = async (columns, filters) => {
    const { data } = await api.post('/produtos/exportar/iniciar', { columns, filters });
    return data;
};

export const startVendaExport = async (columns, filters) => {
    const { data } = await api.post('/vendas/exportar/iniciar', { columns, filters });
    return data;
};


export const startClientExport = async (columns) => {
    const { data } = await api.post('/clientes/exportar/iniciar', { columns });
    return data;
};


// Conversas da Poli: a lista de atendentes vem da propria Poli (cache no backend);
// `atualizar` forca a varredura de novo.
export const getConversaExportAtendentes = async (atualizar = false) => {
    const { data } = await api.get('/conversas/exportar/atendentes', {
        params: atualizar ? { atualizar: 1 } : {},
    });
    return data;
};

export const startConversaExport = async (filters) => {
    const { data } = await api.post('/conversas/exportar/iniciar', { filters });
    return data;
};

// Listas de compras item a item: { data_inicio, data_fim, fornecedor_id, status[] }.
export const startListaCompraExport = async (filtros) => {
    const { data } = await api.post('/listas-compras/exportar/iniciar', filtros);
    return data;
};

export const startMovimentacaoEstoqueExport = async (filtros) => {
    const { data } = await api.post('/estoque/movimentacao/exportar/iniciar', filtros);
    return data;
};

export const getEmitentesXmlNfe = async () => {
    const { data } = await api.get('/nfe/xml/exportar/emitentes');
    return data;
};

export const startXmlNfeExport = async (filtros) => {
    const { data } = await api.post('/nfe/xml/exportar/iniciar', filtros);
    return data;
};

export const getNfeDocumentos = async (params) => {
    const { data } = await api.get('/nfe/documentos', { params });
    return data;
};

export const baixarRelatorioNcmPadrao = async (params) => {
    const response = await api.get('/nfe/relatorio-ncm-padrao', { params, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `ncm_padrao_${params.data_inicio}_a_${params.data_fim}.csv`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export const getNfeDocumentosResumo = async (params) => {
    const { data } = await api.get('/nfe/documentos/resumo', { params });
    return data;
};

export const getNfeDocumentosPendencias = async () => {
    const { data } = await api.get('/nfe/documentos/pendencias');
    return data;
};

export const baixarArquivoNfeDocumento = async (id, formato, nomeArquivo) => {
    try {
        const res = await api.get(`/nfe/documentos/${id}/${formato === 'danfe' ? 'danfe' : 'xml'}`, {
            responseType: 'blob',
            params: formato === 'cancelamento' ? { arquivo: 'cancelamento' } : undefined,
        });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nomeArquivo);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { sucesso: true };
    } catch (err) {
        let mensagem = err.message;
        try {
            const texto = await err.response?.data?.text?.();
            if (texto) {
                const corpo = JSON.parse(texto);
                mensagem = corpo?.message || corpo?.error || mensagem;
            }
        } catch (_) {
            return { error: mensagem };
        }
        return { error: mensagem };
    }
};

export const consultarNfeDocumento = async (id) => {
    try {
        const { data } = await api.post(`/nfe/documentos/${id}/consultar`);
        return data;
    } catch (err) {
        return { error: err.response?.data?.message || err.message };
    }
};


export const getExportStatus = async (jobId) => {
    const { data } = await api.get(`/exportar/status/${jobId}`);
    return data;
};


export const downloadExportFile = async (fileName) => {
    const response = await api.get(`/exportar/download/${fileName}`, {
        responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};


export const getDevolucoesKanban = async (params) => {
    try {
        const res = await api.get(`/devolucoes_kanban?${params}`);
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao buscar devoluções do Kanban:", err);
        return false;
    }
};

export const getDevolucaoDetalhes = async (id) => {
    try {
        const res = await api.get(`/devolucoes_kanban/${id}/detalhes`);
        if (res.status !== 200) return null;
        return res.data;
    } catch (err) {
        console.error("Erro ao buscar detalhes da devolução:", err);
        return null;
    }
};

export const validarVendaParaDevolucaoManual = async (idVenda) => {
    try {
        const res = await api.get(`/devolucoes_kanban/validar-venda/${idVenda}`);
        return res.data;
    } catch (err) {
        return err.response?.data || { elegivel: false, error: err.message };
    }
};

export const criarDevolucaoManual = async (payload) => {
    try {
        const res = await api.post('/devolucoes_kanban/criar-manual', payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const sinalizarDivergenciaDevolucao = async (id, payload) => {
    try {
        const res = await api.post(`/devolucoes_kanban/${id}/sinalizar-divergencia`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const editarDivergenciaDevolucao = async (id, payload) => {
    try {
        const res = await api.put(`/devolucoes_kanban/${id}/divergencia`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const removerDivergenciaDevolucao = async (id) => {
    try {
        const res = await api.delete(`/devolucoes_kanban/${id}/divergencia`);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const getBloqueioProduto = async (produtoId, params = {}) => {
    try {
        const res = await api.get(`/despacho/produto/${produtoId}/bloqueio`, { params });
        return res.data;
    } catch (err) {
        return { error: err.response?.data?.error || 'Não foi possível consultar o bloqueio do produto.' };
    }
};

export const getBloqueioProdutoDevolucao = async (id) => {
    try {
        const res = await api.get(`/devolucoes_kanban/${id}/bloqueio-produto`);
        return res.data;
    } catch (err) {
        return { error: err.response?.data?.error || 'Não foi possível consultar o bloqueio do produto.' };
    }
};

export const atualizarDevolucaoManual = async (id, payload) => {
    try {
        const res = await api.patch(`/devolucoes_kanban/${id}/manual`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const excluirDevolucaoManual = async (id) => {
    try {
        const res = await api.delete(`/devolucoes_kanban/${id}/manual`);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

// Sem err.response = resposta nao chegou (queda de rede ou proxy engoliu o erro);
// traduz o "Network Error" cru do axios pra algo acionavel pro operador.
const erroReembolsoMp = (err) =>
    err.response?.data || {
        error: 'O servidor não respondeu (falha de rede). O estorno pode não ter sido concluído — feche e abra esta janela para conferir o valor já reembolsado antes de tentar de novo.',
    };

// O mesmo estorno atende dois recursos: devolucoes_kanban e reclamacoes.
export const getReembolsoMpInfo = async (id, recurso = 'devolucoes_kanban') => {
    try {
        const res = await api.get(`/${recurso}/${id}/reembolso-mp`);
        return res.data;
    } catch (err) {
        return erroReembolsoMp(err);
    }
};

export const executarReembolsoMp = async (id, payload, recurso = 'devolucoes_kanban') => {
    try {
        const res = await api.post(`/${recurso}/${id}/reembolso-mp`, payload);
        return res.data;
    } catch (err) {
        return erroReembolsoMp(err);
    }
};

export const baixarComprovanteReembolsoMp = async (id, nomeArquivo, recurso = 'devolucoes_kanban') => {
    try {
        const response = await api.get(`/${recurso}/${id}/reembolso-mp/comprovante`, {
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', nomeArquivo || `comprovante-estorno-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        return true;
    } catch (err) {
        console.error("Erro ao baixar comprovante de estorno:", err);
        return false;
    }
};

export const setDevolucaoEstoque = async (id, payload) => {
    try {
        const res = await api.put('/devolucoes_kanban/incluir_estoque', { id, payload });
        return res.data;
    } catch (err) {
        console.error("Erro ao incluir no estoque:", err);
        return false;
    }
};

export const getSugestoesLocalizacaoDespacho = async (produtoEstoqueId) => {
    try {
        const res = await api.get(`/despacho/canceladas/${produtoEstoqueId}/sugestoes-localizacao`);
        return Array.isArray(res.data?.sugestoes) ? res.data.sugestoes : [];
    } catch (err) {
        return [];
    }
};

export const getSugestoesLocalizacaoDevolucao = async (id) => {
    try {
        const res = await api.get(`/devolucoes_kanban/${id}/sugestoes-localizacao`);
        return Array.isArray(res.data?.sugestoes) ? res.data.sugestoes : [];
    } catch (err) {
        console.error("Erro ao buscar sugestões de localização:", err);
        return [];
    }
};

export const reverterDevolucaoEstoque = async (id) => {
    try {
        const res = await api.put('/devolucoes_kanban/reverter_estoque', { id, userId: user.id });
        return res.data;
    } catch (err) {
        console.error("Erro ao reverter estoque:", err);
        return false;
    }
};


export const recrearAnuncioML = async (produto_estoques_id) => {
    try {
        const res = await api.post(`/produtos-estoque/${produto_estoques_id}/reanunciar`);
        if (res.status === 200) {
            return res.data;
        } else {
            return false;
        }
    } catch (error) {
        console.error("Erro ao recriar anúncio:", error.response);
        if (error.response && error.response.data) {
            return error.response.data;
        }
        return false;
    }
};


export const getTicketStats = async () => {
    return await api.get('/tickets/stats');
};

// ==================== LISTAS DE COMPRAS ====================

// Hash do link do fornecedor: as rotas públicas que mexem em item/resposta/divergência
// pelo id exigem o hash da lista no header X-Lista-Hash (o backend confere a dona do id).
// Guardado quando a página carrega a lista, antes de qualquer ação do fornecedor.
let hashListaPublica = null;
const configListaPublica = () => (hashListaPublica ? { headers: { 'X-Lista-Hash': hashListaPublica } } : {});

// Buscar lista de compras por hash (rota pública)
export const buscarListaComprasPorHash = async (hash) => {
    hashListaPublica = hash;
    try {
        const res = await axios.get(`${baseUrlApi}/listas-compras/public/${hash}`);
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao buscar lista de compras:", err);
        return false;
    }
};

// Adicionar resposta do fornecedor a um item
export const adicionarRespostaItem = async (payload) => {
    try {
        const res = await axios.post(`${baseUrlApi}/listas-compras/responder`, payload, configListaPublica());
        if (res.status !== 201) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao adicionar resposta:", err);
        return false;
    }
};

// Fornecedor reverte a confirmação de um item (remove a resposta enquanto pendente)
export const removerRespostaFornecedor = async (respostaId) => {
    try {
        const res = await axios.delete(`${baseUrlApi}/listas-compras/respostas/${respostaId}`, configListaPublica());
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao reverter confirmação:", err);
        return false;
    }
};

// Marcar item como sem estoque
export const marcarItemSemEstoque = async (payload) => {
    try {
        const res = await axios.post(`${baseUrlApi}/listas-compras/sem-estoque`, payload, configListaPublica());
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao marcar item sem estoque:", err);
        return false;
    }
};

// Marcar item como furo de estoque (após já ter respondido)
export const marcarFuroEstoque = async (payload) => {
    try {
        const res = await axios.post(`${baseUrlApi}/listas-compras/marcar-furo-estoque`, payload, configListaPublica());
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao marcar furo de estoque:", err);
        return false;
    }
};

// Finalizar resposta da lista
export const finalizarRespostaLista = async (hash, observacoes_fornecedor) => {
    try {
        const res = await axios.post(`${baseUrlApi}/listas-compras/${hash}/finalizar-resposta`, {
            observacoes_fornecedor
        });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao finalizar resposta:", err);
        return false;
    }
};

// Fornecedor informa o nº do pedido formalizado (rota pública, notifica a equipe)
export const informarPedidoFormalizado = async (hash, numeroPedido) => {
    try {
        const res = await axios.post(`${baseUrlApi}/listas-compras/${hash}/pedido-formalizado`, {
            numero_pedido: numeroPedido
        });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao informar pedido formalizado:", err);
        return false;
    }
};

// Fornecedor declara furo de estoque para um item
export const declararFuroEstoqueItem = async (itemId) => {
    try {
        const res = await axios.post(`${baseUrlApi}/listas-compras/itens/${itemId}/declarar-furo`, undefined, configListaPublica());
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao declarar furo de estoque:", err);
        return false;
    }
};

// Fornecedor desfaz furo de estoque
export const desfazerFuroEstoqueItem = async (itemId) => {
    try {
        const res = await axios.post(`${baseUrlApi}/listas-compras/itens/${itemId}/desfazer-furo`, undefined, configListaPublica());
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao desfazer furo de estoque:", err);
        return false;
    }
};

// Fornecedor adiciona divergência ao item
export const adicionarDivergencia = async (payload) => {
    try {
        const res = await axios.post(`${baseUrlApi}/listas-compras/divergencias`, payload, configListaPublica());
        if (res.status !== 201) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao adicionar divergência:", err);
        return false;
    }
};

// Fornecedor remove divergência (apenas se ainda pendente)
export const removerDivergencia = async (divergenciaId) => {
    try {
        const res = await axios.delete(`${baseUrlApi}/listas-compras/divergencias/${divergenciaId}`, configListaPublica());
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao remover divergência:", err);
        return false;
    }
};

// Fornecedor atualiza divergência pendente (usado pelo inline edit)
export const atualizarDivergencia = async (divergenciaId, payload) => {
    try {
        const res = await axios.put(`${baseUrlApi}/listas-compras/divergencias/${divergenciaId}`, payload, configListaPublica());
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao atualizar divergência:", err);
        return false;
    }
};

// ==================== LISTAS DE COMPRAS - ÁREA INTERNA (COMPRADOR) ====================

// Buscar estatísticas do dashboard
export const getListasComprasStats = async () => {
    try {
        const res = await api.get('/listas-compras/dashboard/stats');
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao buscar estatísticas:", err);
        return false;
    }
};

// Configurações da geração de listas de compras
export const getConfiguracoesListaCompras = async () => {
    try {
        const res = await api.get('/listas-compras/configuracoes');
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao buscar configuracoes:", err);
        return false;
    }
};

export const salvarHorariosListaCompras = async (horarios) => {
    try {
        const res = await api.put('/listas-compras/configuracoes', { horarios_geracao: horarios });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao salvar horarios:", err);
        return err.response?.data || false;
    }
};

// Salva o WhatsApp do comprador que recebe o aviso de lista respondida
export const salvarWhatsappCompradorListaCompras = async (whatsapp) => {
    try {
        const res = await api.put('/listas-compras/configuracoes', { whatsapp_comprador: whatsapp });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao salvar whatsapp do comprador:", err);
        return err.response?.data || false;
    }
};

// Salva os WhatsApps notificados quando o fornecedor informa o nº do pedido formalizado
export const salvarWhatsappsPedidoFormalizado = async (whatsapps) => {
    try {
        const res = await api.put('/listas-compras/configuracoes', { whatsapps_pedido_formalizado: whatsapps });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao salvar whatsapps de pedido formalizado:", err);
        return err.response?.data || false;
    }
};

export const salvarConfigFornecedorListaCompras = async (fornecedorId, payload) => {
    try {
        const res = await api.put(`/listas-compras/fornecedores/${fornecedorId}/configuracoes`, payload);
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao salvar config fornecedor:", err);
        return err.response?.data || false;
    }
};

// Listas abertas (pendente/em_andamento) de um fornecedor — usado no modal "Sem Lista" do /vendas
export const getListasAbertasFornecedor = async (fornecedorId) => {
    try {
        const res = await api.get(`/listas-compras/fornecedores/${fornecedorId}/abertas`);
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao buscar listas abertas do fornecedor:", err);
        return false;
    }
};

// Adiciona manualmente um item_venda a uma lista existente
export const adicionarItemVendaEmLista = async (listaId, itemVendaId) => {
    try {
        const res = await api.post(`/listas-compras/${listaId}/adicionar-item-venda`, {
            item_venda_id: itemVendaId,
        });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao adicionar item em lista existente:", err);
        return err.response?.data || false;
    }
};

// Marca/desmarca item_venda para "ignorar lista de compras pra sempre"
export const marcarIgnorarListaCompras = async (itemVendaId) => {
    try {
        const res = await api.post(`/vendas/itens/${itemVendaId}/ignorar-lista-compras`);
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao marcar ignorar lista de compras:", err);
        return false;
    }
};

export const desmarcarIgnorarListaCompras = async (itemVendaId) => {
    try {
        const res = await api.delete(`/vendas/itens/${itemVendaId}/ignorar-lista-compras`);
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao desmarcar ignorar lista de compras:", err);
        return false;
    }
};

// Listar todas as listas com filtros e paginação
export const getListasCompras = async (params) => {
    try {
        const res = await api.get('/listas-compras', { params });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao buscar listas:", err);
        return false;
    }
};

// Buscar detalhes completos de uma lista
export const getListaCompraDetalhes = async (id) => {
    try {
        const res = await api.get(`/listas-compras/${id}`);
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao buscar detalhes da lista:", err);
        return false;
    }
};

// Criar lista manual
export const criarListaCompraManual = async (payload) => {
    try {
        const res = await api.post('/listas-compras', { ...payload, userId: user.id });
        if (res.status !== 201) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao criar lista:", err);
        return false;
    }
};

// Aprovar ou rejeitar resposta de fornecedor
export const aprovarRespostaFornecedor = async (payload) => {
    try {
        const res = await api.post('/listas-compras/aprovar-resposta', { ...payload, userId: user.id });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao aprovar/rejeitar resposta:", err);
        return false;
    }
};

// Finalizar aprovação da lista inteira
export const finalizarAprovacaoLista = async (id) => {
    try {
        const res = await api.post(`/listas-compras/${id}/finalizar-aprovacao`, { userId: user.id });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao finalizar aprovação:", err);
        if (err.response && err.response.status === 422 && err.response.data) {
            return { erro: true, ...err.response.data };
        }
        return false;
    }
};

// Comprador aceita formalmente furo de estoque
export const aceitarFuroEstoqueItem = async (itemId) => {
    try {
        const res = await api.post(`/listas-compras/itens/${itemId}/aceitar-furo`, { userId: user.id });
        if (res.status !== 200) return { erro: true, message: res.data?.message || null };
        return res.data;
    } catch (err) {
        console.error("Erro ao aceitar furo de estoque:", err);
        return { erro: true, message: err?.response?.data?.message || null };
    }
};

// Comprador desfaz aceite de furo de estoque
export const desfazerAceiteFuroEstoqueItem = async (itemId) => {
    try {
        const res = await api.post(`/listas-compras/itens/${itemId}/desfazer-aceite-furo`, { userId: user.id });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao desfazer aceite de furo:", err);
        return false;
    }
};

// Comprador exclui item da lista de cotação (#1738)
export const excluirItemCotacao = async (itemId) => {
    try {
        const res = await api.post(`/listas-compras/itens/${itemId}/excluir-cotacao`, { userId: user.id });
        if (res.status !== 200) return { erro: true, message: res.data?.message || null };
        return res.data;
    } catch (err) {
        console.error("Erro ao excluir item da cotação:", err);
        return { erro: true, message: err?.response?.data?.message || null };
    }
};

// Comprador desfaz a exclusão do item da lista de cotação (#1738)
export const desfazerExclusaoItemCotacao = async (itemId) => {
    try {
        const res = await api.post(`/listas-compras/itens/${itemId}/desfazer-excluir-cotacao`, { userId: user.id });
        if (res.status !== 200) return { erro: true, message: res.data?.message || null };
        return res.data;
    } catch (err) {
        console.error("Erro ao desfazer exclusão da cotação:", err);
        return { erro: true, message: err?.response?.data?.message || null };
    }
};

// Comprador trata divergência (reconhecer ou dispensar)
export const tratarDivergencia = async (divergenciaId, acao, observacoes_tratamento = null) => {
    try {
        const res = await api.post(`/listas-compras/divergencias/${divergenciaId}/tratar`, {
            acao,
            observacoes_tratamento,
            userId: user.id
        });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao tratar divergência:", err);
        return false;
    }
};

// Comprador aprova ajuste (divergência de qtd/preço): cria resposta com valores ajustados e aprova
export const aprovarAjusteDivergencia = async (divergenciaId) => {
    try {
        const res = await api.post(`/listas-compras/divergencias/${divergenciaId}/aprovar-ajuste`, {
            userId: user.id
        });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao aprovar ajuste:", err);
        return false;
    }
};

// Comprador desfaz a aprovação (ou rejeição) de uma resposta — volta para pendente
export const desfazerAprovacaoResposta = async (respostaId) => {
    try {
        const res = await api.post(`/listas-compras/respostas/${respostaId}/desfazer-aprovacao`, {
            userId: user.id
        });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao desfazer aprovação da resposta:", err);
        return false;
    }
};

// Comprador registra furo de estoque informado pelo fornecedor após confirmação
export const marcarFuroPosConfirmacaoItem = async (itemId, observacoes = null) => {
    try {
        const res = await api.post(`/listas-compras/itens/${itemId}/marcar-furo-pos-confirmacao`, {
            observacoes,
            userId: user.id
        });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao marcar furo pós-confirmação:", err);
        return false;
    }
};

// Atualizar status de envio
export const atualizarStatusEnvioLista = async (id, status_envio, erro_envio = null) => {
    try {
        const res = await api.put(`/listas-compras/${id}/status-envio`, {
            status_envio,
            erro_envio,
            userId: user.id
        });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao atualizar status de envio:", err);
        return false;
    }
};

// Cancelar lista
export const cancelarListaCompra = async (id) => {
    try {
        const res = await api.delete(`/listas-compras/${id}`, { data: { userId: user.id } });
        if (res.status !== 200) return false;
        return res.data;
    } catch (err) {
        console.error("Erro ao cancelar lista:", err);
        return false;
    }
};

// ---- Kanban de listas de compras (Pendente -> Respondido -> Aprovado -> Retirado) ----
export const getListasComprasKanban = async (params = {}) => {
    try { const r = await api.get('/listas-compras/kanban', { params }); return r.data; } catch (e) { console.error('Erro ao carregar kanban de listas:', e); return false; }
};
// Mercadoria retirada no fornecedor. Chamar de novo só atualiza rastreio/observação.
export const marcarListaRetirada = async (id, payload) => {
    try { const r = await api.post(`/listas-compras/${id}/retirado`, payload); return r.data; } catch (e) { return e.response?.data || false; }
};
export const desfazerListaRetirada = async (id) => {
    try { const r = await api.post(`/listas-compras/${id}/desfazer-retirado`); return r.data; } catch (e) { return e.response?.data || false; }
};


export const getWikiTopics = async (category = '', search = '') => {
    try {
        let url = '/support-wiki?';
        if (category) url += `category=${category}&`;
        if (search) url += `search=${search}`;

        const res = await api.get(url);
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar Wiki:", error);
        return [];
    }
};

export const createWikiTopic = async (topicData) => {
    try {
        const formData = new FormData();
        formData.append('title', topicData.title);
        formData.append('category', topicData.category);
        formData.append('excerpt', topicData.excerpt || '');
        formData.append('description', topicData.description || '');
        formData.append('standardResponse', topicData.standardResponse);
        formData.append('parentId', topicData.parentId || '');
        if (topicData.content) {
            formData.append('content', JSON.stringify(topicData.content));
        }
        if (topicData.files && topicData.files.length > 0) {
            topicData.files.forEach((file) => {
                formData.append('attachments[]', file);
            });
        }

        const res = await api.post('/support-wiki', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return { success: true, data: res.data };
    } catch (error) {
        return { success: false, message: error.response?.data?.error || 'Erro ao salvar.' };
    }
};

export const updateWikiTopic = async (id, topicData) => {
    try {
        const formData = new FormData();
        formData.append('_method', 'PUT');
        formData.append('title', topicData.title);
        formData.append('category', topicData.category);
        formData.append('excerpt', topicData.excerpt || '');
        formData.append('description', topicData.description || '');
        formData.append('standardResponse', topicData.standardResponse);
        formData.append('parentId', topicData.parentId || '');
        if (topicData.content) {
            formData.append('content', JSON.stringify(topicData.content));
        }

        if (topicData.new_files && topicData.new_files.length > 0) {
            topicData.new_files.forEach((file) => {
                formData.append('new_attachments[]', file);
            });
        }

        const res = await api.post(`/support-wiki/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return { success: true, data: res.data };
    } catch (error) {
        return { success: false, message: error.response?.data?.error || 'Erro ao atualizar.' };
    }
};

export const deleteWikiTopic = async (id) => {
    try {
        await api.delete(`/support-wiki/${id}`);
        return true;
    } catch {
        return false;
    }
};

export const getWikiCategories = async () => {
    try {
        const res = await api.get('/support-wiki-categorias');
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar categorias da wiki:", error);
        return [];
    }
};

export const createWikiCategory = async (data) => {
    try {
        const res = await api.post('/support-wiki-categorias', data);
        return { success: true, data: res.data };
    } catch (error) {
        return { success: false, message: error.response?.data?.error || 'Erro ao criar categoria.' };
    }
};

export const updateWikiCategory = async (id, data) => {
    try {
        const res = await api.put(`/support-wiki-categorias/${id}`, data);
        return { success: true, data: res.data };
    } catch (error) {
        return { success: false, message: error.response?.data?.error || 'Erro ao atualizar categoria.' };
    }
};

export const deleteWikiCategory = async (id) => {
    try {
        await api.delete(`/support-wiki-categorias/${id}`);
        return { success: true };
    } catch (error) {
        return { success: false, message: error.response?.data?.error || 'Erro ao excluir categoria.' };
    }
};

export const uploadWikiImage = async (file) => {
    try {
        const formData = new FormData();
        formData.append('image', file);
        const res = await api.post('/support-wiki/upload-image', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return res.data?.file?.url || null;
    } catch (error) {
        console.error("Erro ao enviar imagem da wiki:", error);
        return null;
    }
};

export const deleteWikiAttachment = async (id) => {
    try {
        await api.delete(`/support-wiki/attachment/${id}`);
        return true;
    } catch {
        return false;
    }
};

/** Reordena / move páginas da wiki: itens = [{ id, parentId, position }] */
export const reordenarWikiTopicos = async (itens) => {
    try {
        const res = await api.put('/support-wiki/reordenar', { itens });
        return { success: true, data: res.data };
    } catch (error) {
        return { success: false, message: error.response?.data?.error || 'Erro ao reordenar.' };
    }
};

export const sendToGemini = async (message, file = null) => {
    try {
        const formData = new FormData();
        formData.append('message', message);

        if (file) {
            formData.append('file', file);
        }

        const res = await api.post('/gemini/chat', formData);
        return { success: true, data: res.data };
    } catch (error) {
        console.error("Erro Gemini:", error);
        return { success: false, message: 'Erro ao conectar com o servidor.' };
    }
};

export const emitirNfeTaga = async (vendaId, customPayload = null) => {
    try {
        const body = { venda_id: vendaId };
        if (customPayload) {
            body.custom_payload = customPayload;
        }
        const res = await api.post("/nfe/emitir", body);
        return res;
    } catch (error) {
        return error.response;
    }
};

// Emissor padrao da NF-e das vendas do ML por conta (interno x faturador do ML).
export const getConfigEmissorNfeMl = async () => {
    try {
        const res = await api.get('/nfe/emissor-ml/config');
        return res.data?.data || null;
    } catch (error) {
        console.error('Erro ao carregar o emissor de NF-e do ML:', error);
        return null;
    }
};

export const salvarConfigEmissorNfeMl = async (conta, emissorPadrao) => {
    try {
        const res = await api.put('/nfe/emissor-ml/config', { conta, emissor_padrao: emissorPadrao });
        return { ok: true, data: res.data?.data || null };
    } catch (error) {
        return { ok: false, mensagem: mensagemDeErro(error.response?.data ?? error, 'Erro ao salvar o emissor.') };
    }
};

// Parametros fiscais da NF-e de venda que ficam para configurar (CRT 3). So admin.
export const getParametrosFiscaisVenda = async () => {
    try {
        const res = await api.get('/nfe/venda/parametros');
        return res.data?.data || null;
    } catch (error) {
        console.error('Erro ao carregar os parametros fiscais da venda:', error);
        return null;
    }
};

export const salvarParametrosFiscaisVenda = async (crt3) => {
    try {
        const res = await api.put('/nfe/venda/parametros', { crt3 });
        return { ok: true, data: res.data?.data || null };
    } catch (error) {
        return { ok: false, mensagem: mensagemDeErro(error.response?.data ?? error, 'Erro ao salvar os parametros.') };
    }
};

export const downloadNfeArquivo = async (url) => {
    try {
        const res = await api.get(url, { responseType: 'blob' });
        return res;
    } catch (error) {
        return false;
    }
};

export const getVendasManuais = async (page = 1, filters = {}) => {
    try {
        const queryParams = new URLSearchParams({
            page: page,
            ...filters
        }).toString();

        const res = await api.get(`/nfe/vendas-manuais?${queryParams}`);
        return res.data;
    } catch (error) {
        return false;
    }
};

export const getEstatisticasNfe = () => api.get('/nfe/estatisticas');

export const sincronizarStatusNfe = (vendaId) =>
    api.post(`/nfe/sincronizar-status/${vendaId}`);

export const finalizarDevolucaoManual = async (id, obs) => {
    try {
        const response = await api.put('/devolucoes_kanban/finalizar_manual', { id, obs });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
};

export const sincronizarDevolucao = async (id) => {
    try {
        const res = await api.post('/devolucoes_kanban/sincronizar', { id });
        return res.data;
    } catch (err) {
        return err.response ? err.response.data : { error: err.message };
    }
};

export const getRazoesRevisao = async (id) => {
    try {
        const qs = id ? `?id=${id}` : '';
        const res = await api.get(`/devolucoes_review/razoes${qs}`);
        return res.data;
    } catch (err) {
        console.error('Erro ao buscar razões de revisão:', err);
        return [];
    }
};

export const marcarRevisaoOk = async (id) => {
    try {
        const res = await api.post('/devolucoes_review/ok', { id });
        return res.data;
    } catch (err) {
        return err.response ? err.response.data : { error: err.message };
    }
};

export const marcarRevisaoFalha = async (id, { reason, message, attachments = [], order_id = null }) => {
    try {
        const payload = { id, reason, message, attachments };
        if (order_id) payload.order_id = order_id;
        const res = await api.post('/devolucoes_review/falha', payload);
        return res.data;
    } catch (err) {
        return err.response ? err.response.data : { error: err.message };
    }
};

export const uploadAttachmentRevisao = async (id, file) => {
    try {
        const fd = new FormData();
        fd.append('id', id);
        fd.append('file', file);
        const res = await api.post('/devolucoes_review/upload_attachment', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return res.data;
    } catch (err) {
        return err.response ? err.response.data : { error: err.message };
    }
};

export const reuploadAttachmentExistente = async (id, path) => {
    try {
        const res = await api.post('/devolucoes_review/reupload_existente', { id, path });
        return res.data;
    } catch (err) {
        return err.response ? err.response.data : { error: err.message };
    }
};

export const consultarCustoEnvioDevolucao = async (id) => {
    try {
        const res = await api.post('/devolucoes_review/custo_envio', { id });
        return res.data;
    } catch (err) {
        return err.response ? err.response.data : { error: err.message };
    }
};





export const getV3VendasHoje = () => api.get('/dashboard-v3/vendas').then(res => res.data);
export const getV3GraficoSemanal = () => api.get('/dashboard-v3/grafico-semanal').then(res => res.data);
export const getV3GraficoMensal = () => api.get('/dashboard-v3/grafico-mensal').then(res => res.data);
export const getV3GraficoUltimos30 = () => api.get('/dashboard-v3/grafico-30dias').then(res => res.data);
export const getV3DadosGerais = () => api.get('/dashboard-v3/dados-gerais').then(res => res.data);
export const getV3Logistica = () => api.get('/dashboard-v3/logistica').then(res => res.data);
export const getV3Produtos = () => api.get('/dashboard-v3/produtos').then(res => res.data);
export const getV3Compras = (meses = 12) => api.get('/dashboard-v3/compras', { params: { meses } }).then(res => res.data);
export const getV3ConversaoML = () => api.get('/dashboard-v3/conversao-ml').then(res => res.data);
export const getV3Vendedores = () => api.get('/dashboard-v3/vendedores').then(res => res.data);
export const getRadarDashboard = () => api.get('/dashboard-v3/radar').then(res => res.data);

// ── Atalhos da navbar (por usuário, validados por permissão no backend) ──
export const getAtalhos = async () => {
    try { const r = await api.get('/atalhos'); return r.data; }
    catch (e) { console.error('Erro ao buscar atalhos:', e); return false; }
};
export const salvarAtalhos = async (paginas) => {
    try { const r = await api.put('/atalhos', { paginas }); return r.data; }
    catch (e) { console.error('Erro ao salvar atalhos:', e); return false; }
};

// 4. Módulos Futuros (Mockados por enquanto)
export const getV3PosVenda = () => Promise.resolve({});






export const getClientes = async (params) => {
    try {
        const res = await api.get('/clientes', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const createCliente = async (data) => {
    try {
        const res = await api.post('/clientes', data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const updateCliente = async (id, data) => {
    try {
        const res = await api.put(`/clientes/${id}`, data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const atualizarClienteVenda = async (vendaId, data) => {
    try {
        const res = await api.put(`/vendas/${vendaId}/cliente`, data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const getDadosEntregaCombinar = async (vendaId) => {
    try {
        const res = await api.get(`/vendas/${vendaId}/dados-entrega-combinar`);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const confirmarEntregaCombinar = async (vendaId, data) => {
    try {
        const res = await api.post(`/vendas/${vendaId}/confirmar-entrega`, data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const deleteCliente = async (id) => {
    try {
        const res = await api.delete(`/clientes/${id}`);
        return res;
    } catch (e) {
        return e.response;
    }
};


// ==================== DRE ====================

export const getDre = async (params) => {
    try {
        const res = await api.get('/dre', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const getDreDetalhado = async (params) => {
    try {
        const res = await api.get('/dre/detalhado', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const getDreSyncStatus = async () => {
    try {
        const res = await api.get('/dre/sync-status');
        return res.data;
    } catch {
        return false;
    }
};

export const getDreCategorias = async () => {
    try {
        const res = await api.get('/dre/categorias');
        return res.data;
    } catch {
        return false;
    }
};

export const getDreCanais = async () => {
    try {
        const res = await api.get('/dre/canais');
        return res.data;
    } catch {
        return false;
    }
};

// De/Para das origens de custo de IA no DRE (#2384): mapeamento administravel
// em tela, para reclassificar origem nova sem deploy.
export const getDreIaOrigens = async () => {
    try {
        const res = await api.get('/dre/ia-origens');
        return res.data;
    } catch {
        return false;
    }
};

export const updateDreIaOrigem = async (id, data) => {
    try {
        const res = await api.put(`/dre/ia-origens/${id}`, data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const getDreComissaoAgentes = async () => {
    try {
        const res = await api.get('/dre/comissao-agentes');
        return res.data;
    } catch {
        return false;
    }
};

export const updateDreComissaoAgente = async (id, data) => {
    try {
        const res = await api.put(`/dre/comissao-agentes/${id}`, data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const exportarDre = async (params) => {
    try {
        const res = await api.get('/dre/exportar', { params, responseType: 'blob' });
        return res.data;
    } catch {
        return false;
    }
};

export const getDreCustosTemplate = async () => {
    try {
        const res = await api.get('/dre/custos/template', { responseType: 'blob' });
        return res.data;
    } catch {
        return false;
    }
};

export const validarImportacaoDreCustos = async (file) => {
    try {
        const formData = new FormData();
        formData.append('arquivo', file);
        const res = await api.post('/dre/custos/importar/validar', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return { ok: true, ...res.data };
    } catch (error) {
        return { ok: false, message: error?.response?.data?.message || 'Erro ao validar o arquivo' };
    }
};

export const confirmarImportacaoDreCustos = async (despesas) => {
    try {
        const res = await api.post('/dre/custos/importar/confirmar', { despesas });
        return { ok: true, ...res.data };
    } catch (error) {
        return { ok: false, ...(error?.response?.data || { message: 'Erro ao importar as despesas' }) };
    }
};

export const getDreCustos = async (params) => {
    try {
        const res = await api.get('/dre/custos', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const createDreCusto = async (data) => {
    try {
        const res = await api.post('/dre/custos', data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const updateDreCusto = async (id, data) => {
    try {
        const res = await api.put(`/dre/custos/${id}`, data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const deleteDreCusto = async (id) => {
    try {
        const res = await api.delete(`/dre/custos/${id}`);
        return res;
    } catch (e) {
        return e.response;
    }
};


export const createDreCategoria = async (data) => {
    try {
        const res = await api.post('/dre/categorias', data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const updateDreCategoria = async (id, data) => {
    try {
        const res = await api.put(`/dre/categorias/${id}`, data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const deleteDreCategoria = async (id) => {
    try {
        const res = await api.delete(`/dre/categorias/${id}`);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const getDreFuroEstoque = async (params) => {
    try {
        const res = await api.get('/dre/furo-estoque', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const setDreFuroEstoqueCmv = async (vendaId, data) => {
    try {
        const res = await api.put(`/dre/furo-estoque/${vendaId}/cmv`, data);
        return res;
    } catch (e) {
        return e.response;
    }
};

export const excluirPerguntaML = async (id, conta, userId) => {
    try {
        const res = await api.post(`/perguntas_mercado_livre/excluir`, { id, conta, userId: user.id });
        return res;
    } catch (e) {
        return e.response;
    }
};

// ==================== POLI - Assistente de Vendas IA ====================

export const getPoliContatosVendas = async (status = null, dias = 2) => {
    try {
        const params = new URLSearchParams();
        if (status !== null) params.append('status', status);
        if (dias) params.append('dias', dias);
        const query = params.toString();
        const res = await api.get(`/poli/vendas/contatos${query ? `?${query}` : ''}`);
        return res.data;
    } catch {
        return false;
    }
};

export const getPoliMensagensContato = async (contactId, sort = '-created_at', page = 1) => {
    try {
        const res = await api.get(`/poli/chats/contato/${contactId}/mensagens?sort=${sort}&page=${page}`);
        return res.data;
    } catch {
        return false;
    }
};

export const postPoliAssistente = async (contactId) => {
    try {
        const res = await api.post(`/poli/assistente/${contactId}`, {}, { timeout: 300000 });
        return res.data;
    } catch (err) {
        // Captura corpo da resposta de erro para ter acesso aos campos `erro` e `tipo`
        if (err?.response?.data) {
            return err.response.data;
        }
        return false;
    }
};

export const getPoliAssistente = async (contactId) => {
    try {
        const res = await api.get(`/poli/assistente/${contactId}`);
        return res.data;
    } catch {
        return false;
    }
};

export const getPoliHistoricoSugestoes = async (contactId, limit = 20) => {
    try {
        const res = await api.get(`/poli/assistente/${contactId}/historico?limit=${limit}`);
        return res.data;
    } catch {
        return false;
    }
};

export const extrairProdutosSugestao = async (sugestaoId) => {
    try {
        const res = await api.post(`/poli/sugestao/${sugestaoId}/extrair-produtos`);
        return res.data;
    } catch (error) {
        if (error.response && error.response.data) {
            return error.response.data;
        }
        return false;
    }
};

export const postPoliEnviarTexto = async (contactId, message) => {
    try {
        const res = await api.post(`/poli/enviar-texto/${contactId}`, { message });
        return res.data;
    } catch {
        return false;
    }
};

// ── Chat IA (assistente interno vendedores) ──
export const getChatIAConversas = async (limit) => {
    try {
        const params = {};
        if (limit) params.limit = limit;
        const res = await api.get('/chat-ia', { params });
        return res.data;
    } catch {
        return false;
    }
};

// Cria a solicitação (retorna { solicitacao_id }); a resposta é processada em
// background no backend e acompanhada via getChatIASolicitacao (polling).
export const postChatIA = async (mensagem, { imagens, pdf, audio } = {}) => {
    try {
        const formData = new FormData();
        if (mensagem) formData.append('mensagem', mensagem);
        if (imagens) imagens.forEach(img => formData.append('imagens[]', img));
        if (pdf) formData.append('pdf', pdf);
        if (audio) formData.append('audio', audio);
        const res = await api.post('/chat-ia', formData, {
            timeout: 120000,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return res.data;
    } catch (e) {
        if (e.response?.data) return e.response.data;
        return false;
    }
};

export const getChatIASolicitacao = async (solicitacaoId) => {
    try {
        const res = await api.get(`/chat-ia/solicitacao/${solicitacaoId}`);
        return res.data;
    } catch {
        return false;
    }
};

export const getChatIAConversa = async (chatId) => {
    try {
        const res = await api.get(`/chat-ia/${chatId}`);
        return res.data;
    } catch {
        return false;
    }
};

export const postChatIAMensagem = async (chatId, mensagem, { imagens, pdf, audio } = {}) => {
    try {
        const formData = new FormData();
        if (mensagem) formData.append('mensagem', mensagem);
        if (imagens) imagens.forEach(img => formData.append('imagens[]', img));
        if (pdf) formData.append('pdf', pdf);
        if (audio) formData.append('audio', audio);
        const res = await api.post(`/chat-ia/${chatId}/mensagem`, formData, {
            timeout: 120000,
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return res.data;
    } catch (e) {
        if (e.response?.data) return e.response.data;
        return false;
    }
};

export const deleteChatIA = async (chatId) => {
    try {
        const res = await api.delete(`/chat-ia/${chatId}`);
        return res.data;
    } catch {
        return false;
    }
};

// ── Compatibilidade (catálogo oficial partslink24) ──
export const getCompatibilidadeCatalogos = async () => {
    try { const res = await api.get('/compatibilidade-catalogo/catalogos'); return res.data; }
    catch { return false; }
};

// Cria a verificação (retorna { solicitacao_id }); roda em background e é
// acompanhada via getCompatibilidadeSolicitacao (polling).
export const postCompatibilidadeVerificar = async (params) => {
    try { const res = await api.post('/compatibilidade-catalogo/verificar', params); return res.data; }
    catch (e) { if (e.response?.data) return e.response.data; return false; }
};

export const getCompatibilidadeSolicitacao = async (id) => {
    try { const res = await api.get(`/compatibilidade-catalogo/solicitacao/${id}`); return res.data; }
    catch { return false; }
};

// Dados do pedido do e-commerce (cliente, itens, valores, entrega) p/ o modal de detalhe.
export const getCompatibilidadeSolicitacaoPedido = async (id) => {
    try { const res = await api.get(`/compatibilidade-catalogo/solicitacao/${id}/pedido`); return res.data; }
    catch { return false; }
};

export const getCompatibilidadeHistorico = async (tipo = 'manual') => {
    try { const res = await api.get('/compatibilidade-catalogo/historico', { params: { tipo } }); return res.data; }
    catch { return false; }
};

export const getCompatibilidadeEcommerce = async () => {
    try { const res = await api.get('/compatibilidade-catalogo/ecommerce'); return res.data; }
    catch { return false; }
};

export const postCompatibilidadeEcommerceVerificar = async (limite = 8) => {
    try { const res = await api.post('/compatibilidade-catalogo/ecommerce/verificar', { limite }); return res.data; }
    catch (e) { if (e.response?.data) return e.response.data; return false; }
};

// Pedidos do Mercado Livre travados em pendente pela regra dos R$ 2.500.
export const getCompatibilidadeMercadoLivre = async () => {
    try { const res = await api.get('/compatibilidade-catalogo/mercadolivre'); return res.data; }
    catch { return false; }
};

export const postCompatibilidadeMercadoLivreVerificar = async (limite = 8) => {
    try { const res = await api.post('/compatibilidade-catalogo/mercadolivre/verificar', { limite }); return res.data; }
    catch (e) { if (e.response?.data) return e.response.data; return false; }
};

// ── Usuarios CRUD ──
export const getUsuarios = async (params) => {
    try {
        const res = await api.get('/usuarios', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const getUsuario = async (id) => {
    try {
        const res = await api.get(`/usuarios/${id}`);
        return res.data;
    } catch {
        return false;
    }
};

export const createUsuario = async (data) => {
    try {
        const res = await api.post('/usuarios', data);
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const updateUsuario = async (id, data) => {
    try {
        const res = await api.put(`/usuarios/${id}`, data);
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

// Bloqueia/desbloqueia o acesso. Ao bloquear, a API apaga os tokens do usuario
// e ele cai no login na proxima chamada que fizer.
export const toggleBloqueioUsuario = async (id, bloqueado) => {
    try {
        const res = await api.put(`/usuarios/${id}/bloqueio`, { bloqueado });
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

// ── Permissoes ──
export const getPermissoesUsuario = async (id) => {
    try {
        const res = await api.get(`/usuarios/${id}/permissoes`);
        return res.data;
    } catch {
        return false;
    }
};

export const updatePermissoesUsuario = async (id, permissoes) => {
    try {
        const res = await api.put(`/usuarios/${id}/permissoes`, { permissoes });
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const getPaginasDisponiveis = async () => {
    try {
        const res = await api.get('/paginas-disponiveis');
        return res.data;
    } catch {
        return false;
    }
};

export const getLogAcessos = async (params) => {
    try {
        const res = await api.get('/log-acessos', { params });
        return res.data;
    } catch {
        return false;
    }
};

// ==================== Desempenho de Atendentes ====================

export const getDesempenhoDashboard = async (params = {}) => {
    try {
        const res = await api.get('/desempenho/dashboard', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const getDesempenhoAtendentes = async (params = {}) => {
    try {
        const res = await api.get('/desempenho/atendentes', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const createDesempenhoAtendente = async (data) => {
    try {
        const res = await api.post('/desempenho/atendentes', data);
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const updateDesempenhoAtendente = async (id, data) => {
    try {
        const res = await api.put(`/desempenho/atendentes/${id}`, data);
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const deleteDesempenhoAtendente = async (id) => {
    try {
        const res = await api.delete(`/desempenho/atendentes/${id}`);
        return res.data ?? true;
    } catch {
        return false;
    }
};

export const getDesempenhoAtendenteHistorico = async (id, params = {}) => {
    try {
        const res = await api.get(`/desempenho/atendentes/${id}/historico`, { params });
        return res.data;
    } catch {
        return false;
    }
};

export const getDesempenhoPoliUsers = async (params = {}) => {
    try {
        const res = await api.get('/desempenho/poli-users', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const getDesempenhoDepartamentosConfigs = async () => {
    try {
        const res = await api.get('/desempenho/departamentos/configs');
        return res.data;
    } catch {
        return false;
    }
};

export const updateDesempenhoDepartamento = async (id, data) => {
    try {
        const res = await api.put(`/desempenho/departamentos/${id}/config`, data);
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const getDesempenhoTarefasTemplates = async (params = {}) => {
    try {
        const res = await api.get('/desempenho/tarefas-templates', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const createDesempenhoTarefaTemplate = async (data) => {
    try {
        const res = await api.post('/desempenho/tarefas-templates', data);
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const updateDesempenhoTarefaTemplate = async (id, data) => {
    try {
        const res = await api.put(`/desempenho/tarefas-templates/${id}`, data);
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const deleteDesempenhoTarefaTemplate = async (id) => {
    try {
        const res = await api.delete(`/desempenho/tarefas-templates/${id}`);
        return res.data ?? true;
    } catch {
        return false;
    }
};

export const getDesempenhoTarefasDiarias = async (params = {}) => {
    try {
        const res = await api.get('/desempenho/tarefas-diarias', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const getDesempenhoAvaliacoes = async (params = {}) => {
    try {
        const res = await api.get('/desempenho/avaliacoes', { params });
        return res.data;
    } catch {
        return false;
    }
};

export const getDesempenhoAvaliacao = async (id) => {
    try {
        const res = await api.get(`/desempenho/avaliacoes/${id}`);
        return res.data;
    } catch {
        return false;
    }
};

export const rodarDesempenhoAvaliacoes = async (data) => {
    try {
        const res = await api.post('/desempenho/avaliacoes/rodar', data, { timeout: 300000 });
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const sincronizarDesempenho = async (data) => {
    try {
        const res = await api.post('/desempenho/sincronizar', data, { timeout: 600000 });
        return res.data;
    } catch (e) {
        return e.response || false;
    }
};

export const getDesempenhoRamalInternoPresencaRealtime = async (params = {}) => {
    try {
        const res = await api.get('/desempenho/ramal-interno/presenca-realtime', { params, timeout: 30000 });
        return res.data;
    } catch (e) {
        return e.response?.data || false;
    }
};

export const getSoftphoneCredentials = async () => {
    try {
        const res = await api.get('/softphone/credentials');
        return res.data;
    } catch (e) {
        return { error: e.response?.data?.error || 'Falha ao buscar credenciais', status: e.response?.status };
    }
};

export const lookupSoftphoneCliente = async (numero) => {
    try {
        const res = await api.get('/softphone/lookup', { params: { numero } });
        return res.data;
    } catch (e) {
        return { data: null };
    }
};

export const listarSoftphoneChamadas = async (params = {}) => {
    try {
        const res = await api.get('/softphone/chamadas', { params });
        return res.data;
    } catch (e) {
        return false;
    }
};

export const registrarSoftphoneChamada = async (payload) => {
    try {
        const res = await api.post('/softphone/chamadas', payload);
        return res.data;
    } catch (e) {
        return false;
    }
};

export const atualizarSoftphoneChamada = async (id, payload) => {
    try {
        const res = await api.patch(`/softphone/chamadas/${id}`, payload);
        return res.data;
    } catch (e) {
        return false;
    }
};

export const getSoftphoneConfig = async () => {
    try {
        const res = await api.get('/softphone/config');
        return res.data;
    } catch (e) {
        return false;
    }
};

export const saveSoftphoneConfig = async (payload) => {
    try {
        const res = await api.put('/softphone/config', payload);
        return res.data;
    } catch (e) {
        return e.response?.data || false;
    }
};

export const getSoftphoneRamalStatus = async () => {
    try {
        const res = await api.get('/softphone/ramal-status', { timeout: 15000 });
        return res.data;
    } catch (e) {
        return false;
    }
};

export const heartbeatSoftphone = async () => {
    try {
        const res = await api.post('/softphone/heartbeat', null, { timeout: 8000 });
        return res.data;
    } catch (e) {
        return false;
    }
};

export const getSoftphoneChamada = async (id) => {
    try {
        const res = await api.get(`/softphone/chamadas/${id}`);
        return res.data;
    } catch (e) {
        return false;
    }
};

export const getSoftphoneGlobalConfig = async () => {
    try {
        const res = await api.get('/softphone/global-config');
        return res.data;
    } catch (e) {
        return false;
    }
};

export const saveSoftphoneGlobalConfig = async (payload) => {
    try {
        const res = await api.put('/softphone/global-config', payload);
        return res.data;
    } catch (e) {
        return e.response?.data || false;
    }
};

export const listarSoftphoneUsuariosComChamadas = async () => {
    try {
        const res = await api.get('/softphone/usuarios-com-chamadas');
        return res.data;
    } catch (e) {
        return false;
    }
};

export const getSoftphoneAudioUrl = (id) => {
    const base = api.defaults.baseURL || '';
    return `${base}/softphone/chamadas/${id}/audio`;
};

export const getSoftphoneAudioBlob = async (id) => {
    try {
        const res = await api.get(`/softphone/chamadas/${id}/audio`, { responseType: 'blob', timeout: 60000 });
        return res.data;
    } catch (e) {
        return null;
    }
};

export const transcreverSoftphoneChamada = async (id, audioBlob = null) => {
    try {
        const form = new FormData();
        if (audioBlob && (audioBlob.atendente || audioBlob.cliente)) {
            if (audioBlob.atendente) form.append('audio_atendente', audioBlob.atendente, `chamada_${id}_atend.webm`);
            if (audioBlob.cliente) form.append('audio_cliente', audioBlob.cliente, `chamada_${id}_clien.webm`);
        } else if (audioBlob) {
            form.append('audio', audioBlob, `chamada_${id}.webm`);
        }
        const res = await api.post(`/softphone/chamadas/${id}/transcrever`, form, {
            timeout: 240000,
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return res.data;
    } catch (e) {
        return e.response?.data || { error: 'Falha ao transcrever' };
    }
};

export const getRevisaoEstoquePosicoes = (params = {}) =>
    api.get('/revisao-estoque/posicoes', { params });

export const getRevisaoEstoqueItensPosicao = (posicao) =>
    api.get(`/revisao-estoque/posicao/${encodeURIComponent(posicao)}`);

export const buscarProdutoRevisaoEstoque = (q, posicao) =>
    api.get('/revisao-estoque/buscar-produto', { params: { q, posicao } });

export const salvarRevisaoEstoque = (payload) => api.post('/revisao-estoque', payload);

export const getRevisaoEstoqueHistorico = (params = {}) =>
    api.get('/revisao-estoque/historico', { params });

export const getRevisaoEstoqueUsuarios = () =>
    api.get('/revisao-estoque/usuarios-historico');

export const getRevisaoEstoqueDetalhe = (id) => api.get(`/revisao-estoque/${id}`);

// ── Conferência em andamento (autosave da contagem) ──
// A rota da posição (getRevisaoEstoqueItensPosicao) já devolve o estado salvo
// quando existe, junto com o bloco `andamento`.
export const salvarItemRevisaoAndamento = (posicao, item) =>
    api.put(`/revisao-estoque/andamento/${encodeURIComponent(posicao)}/item`, item);

export const removerItemRevisaoAndamento = (posicao, produtoId) =>
    api.delete(`/revisao-estoque/andamento/${encodeURIComponent(posicao)}/item/${produtoId}`);

export const salvarObservacaoRevisaoAndamento = (posicao, observacao) =>
    api.put(`/revisao-estoque/andamento/${encodeURIComponent(posicao)}/observacao`, { observacao });

export const descartarRevisaoAndamento = (posicao) =>
    api.delete(`/revisao-estoque/andamento/${encodeURIComponent(posicao)}`);

export const getTransferenciaEstoquePosicoes = (params = {}) =>
    api.get('/transferencia-estoque/posicoes', { params });

export const getTransferenciaEstoqueItens = (posicao) =>
    api.get(`/transferencia-estoque/posicao/${encodeURIComponent(posicao)}`);

export const salvarTransferenciaEstoque = (payload) => api.post('/transferencia-estoque', payload);

export const getTransferenciaEstoqueHistorico = (params = {}) =>
    api.get('/transferencia-estoque/historico', { params });

export const getTransferenciaEstoqueDetalhe = (id) => api.get(`/transferencia-estoque/${id}`);

export const getImagens = (params = {}) =>
    api.get('/imagens', { params });

export const getImagensProduto = (produtoId) =>
    api.get(`/imagens/produto/${produtoId}`);

export const getImagensContadores = (params = {}) =>
    api.get('/imagens/contadores', { params });

export const getLogsImagens = (params = {}) =>
    api.get('/imagens/logs', { params });

export const getImagensFornecedores = () =>
    api.get('/imagens/fornecedores-disponiveis');

export const getImagensUrlsBatch = (produtoIds) =>
    api.post('/imagens/urls-batch', { produto_ids: produtoIds });

export const uploadImagem = async ({ produto_id, arquivo, principal = false, ordem = 0, onProgress = null }) => {
    const formData = new FormData();
    formData.append('produto_id', produto_id);
    formData.append('arquivo', arquivo);
    if (principal) formData.append('principal', 1);
    if (ordem) formData.append('ordem', ordem);
    return api.post('/imagens', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
            if (onProgress && e.total) {
                onProgress(Math.round((e.loaded * 100) / e.total));
            }
        },
    });
};

export const importarImagemUrl = (payload) =>
    api.post('/imagens/importar-url', payload);

export const updateImagem = (id, payload) =>
    api.put(`/imagens/${id}`, payload);

export const aprovarImagem = (id) =>
    api.patch(`/imagens/${id}/aprovar`);

export const rejeitarImagem = (id, motivo = null) =>
    api.patch(`/imagens/${id}/rejeitar`, { motivo });

export const marcarImagemPendente = (id) =>
    api.patch(`/imagens/${id}/pendente`);

export const definirImagemPrincipal = (id) =>
    api.patch(`/imagens/${id}/principal`);

export const reordenarImagens = (itens) =>
    api.post('/imagens/reordenar', { itens });

export const aprovarImagensMassa = (ids) =>
    api.post('/imagens/aprovar-massa', { ids });

export const rejeitarImagensMassa = (ids, motivo = null) =>
    api.post('/imagens/rejeitar-massa', { ids, motivo });

export const excluirImagensMassa = (ids) =>
    api.post('/imagens/excluir-massa', { ids });

export const excluirImagensMassaPermanente = (ids) =>
    api.post('/imagens/excluir-massa-permanente', { ids });

export const deletarImagem = (id) =>
    api.delete(`/imagens/${id}`);

export const restaurarImagem = (id) =>
    api.post(`/imagens/${id}/restaurar`);

export const excluirImagemPermanente = (id) =>
    api.delete(`/imagens/${id}/permanente`);

export const buscarImagensAutomatico = (produtoId) =>
    api.post(`/imagens/buscar-automatico/${produtoId}`);

export const getAnunciosMLProduto = (produtoId) =>
    api.get(`/imagens/anuncios-ml/${produtoId}`);

export const sincronizarImagensML = (produtoId, payload = {}) =>
    api.post(`/imagens/sincronizar-ml/${produtoId}`, payload);

export const bloquearImagem = (imagemId, escopo, motivo = null) =>
    api.post(`/imagens/${imagemId}/bloquear`, { escopo, motivo });

export const desbloquearImagem = (bloqueioId) =>
    api.delete(`/imagens/bloqueios/${bloqueioId}`);

export const listarImagensBloqueadas = (params = {}) =>
    api.get('/imagens/bloqueios', { params });

export const getImagensContadoresIa = (params = {}) =>
    api.get('/imagens/contadores-ia', { params });

export const analisarImagemIa = (id) =>
    api.post(`/imagens/${id}/analisar-ia`);

export const analisarImagensIaMassa = (payload = {}) =>
    api.post('/imagens/analisar-ia-massa', payload);

export const feedbackImagemIa = (id, feedback) =>
    api.patch(`/imagens/${id}/ia-feedback`, { feedback });

export const autoCorrigirImagemIa = (id) =>
    api.post(`/imagens/${id}/auto-corrigir`);

export const listarMigracoes = () =>
    api.get('/migracao');

export const getMigracao = (id) =>
    api.get(`/migracao/${id}`);

export const iniciarMigracao = (payload) =>
    api.post('/migracao', payload);

// ──────────────────────────── Comparador de Preços ────────────────────────────
export const comparadorDashboard = (params = {}) =>
    api.get('/comparador/dashboard', { params });

export const comparadorGetConfig = () =>
    api.get('/comparador/configuracoes');

export const comparadorSaveConfig = (payload) =>
    api.put('/comparador/configuracoes', payload);

export const comparadorListarFornecedores = () =>
    api.get('/comparador/fornecedores');

export const comparadorListarMarcas = (params = {}) =>
    api.get('/comparador/marcas', { params });

export const comparadorBuscarProdutos = (q) =>
    api.get('/comparador/produtos/buscar', { params: { q } });

export const comparadorPreviewSync = (payload) =>
    api.post('/comparador/sincronizacoes/preview', payload);

export const comparadorDispatchSync = (payload) =>
    api.post('/comparador/sincronizacoes', payload);

export const comparadorListarSyncs = (params = {}) =>
    api.get('/comparador/sincronizacoes', { params });

export const comparadorDetalhesSync = (id) =>
    api.get(`/comparador/sincronizacoes/${id}`);

export const comparadorStatusSync = (id) =>
    api.get(`/comparador/sincronizacoes/${id}/status`);

export const comparadorCancelarSync = (id) =>
    api.post(`/comparador/sincronizacoes/${id}/cancelar`);

export const comparadorListarItensSync = (id, params = {}) =>
    api.get(`/comparador/sincronizacoes/${id}/itens`, { params });

export const comparadorListarResultadosItem = (id, itemId) =>
    api.get(`/comparador/sincronizacoes/${id}/itens/${itemId}/resultados`);

export const comparadorExportarCsvUrl = (id) =>
    `${api.defaults.baseURL}/comparador/sincronizacoes/${id}/exportar-csv`;

export const comparadorHistoricoProduto = (produtoId, params = {}) =>
    api.get(`/comparador/produtos/${produtoId}/historico`, { params });

// ── Precificação Inteligente (sistema de níveis) ──────────────────────────
export const precificacaoDashboard = () =>
    api.get('/precificacao/dashboard');

export const precificacaoGetConfig = () =>
    api.get('/precificacao/configuracoes');

export const precificacaoSaveConfig = (payload) =>
    api.put('/precificacao/configuracoes', payload);

export const precificacaoListarFornecedores = () =>
    api.get('/precificacao/fornecedores');

export const precificacaoPreviewExecucao = (payload) =>
    api.post('/precificacao/execucoes/preview', payload);

export const precificacaoDispatchExecucao = (payload) =>
    api.post('/precificacao/execucoes', payload);

export const precificacaoListarExecucoes = (params = {}) =>
    api.get('/precificacao/execucoes', { params });

export const precificacaoDetalheExecucao = (id) =>
    api.get(`/precificacao/execucoes/${id}`);

export const precificacaoStatusExecucao = (id) =>
    api.get(`/precificacao/execucoes/${id}/status`);

export const precificacaoCancelarExecucao = (id) =>
    api.post(`/precificacao/execucoes/${id}/cancelar`);

export const precificacaoListarItens = (id, params = {}) =>
    api.get(`/precificacao/execucoes/${id}/itens`, { params });

export const precificacaoResumoExecucao = (id) =>
    api.get(`/precificacao/execucoes/${id}/resumo`);

export const precificacaoBaixarCsv = async (id) => {
    const r = await api.get(`/precificacao/execucoes/${id}/exportar-csv`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = `precificacao_execucao_${id}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};

export const precificacaoListarEstados = (params = {}) =>
    api.get('/precificacao/estados', { params });

export const precificacaoDetalheProduto = (produtoId) =>
    api.get(`/precificacao/produtos/${produtoId}`);

// ── Bot de Auto Atendimento (Poli) ──────────────────────────
export const getBotAtendimento = () =>
    api.get('/bot-atendimento');

export const updateBotAtendimentoConfig = (payload) =>
    api.put('/bot-atendimento/config', payload);

export const buscarContatosBot = (q) =>
    api.get('/bot-atendimento/buscar-contatos', { params: { q } });

export const adicionarContatoBot = (contato) =>
    api.post('/bot-atendimento/contatos', contato);

export const atualizarContatoBot = (id, ativo) =>
    api.put(`/bot-atendimento/contatos/${id}`, { ativo });

export const removerContatoBot = (id) =>
    api.delete(`/bot-atendimento/contatos/${id}`);

export const verificarConversasBot = () =>
    api.post('/bot-atendimento/verificar');

export const responderVerificacaoBot = (id) =>
    api.post(`/bot-atendimento/verificacao/${id}/responder`);

export const responderTodasVerificacaoBot = () =>
    api.post('/bot-atendimento/verificacao/responder-todas');

export const getBotUsoIA = (params = {}) =>
    api.get('/bot-atendimento/uso', { params });

// ── Limite de cotações do bot (aba "Cotações" da tela /bot-atendimento) ──
export const getBotLimiteCotacao = (params = {}) =>
    api.get('/bot-limite-cotacao', { params });

export const updateBotLimiteCotacaoConfig = (payload) =>
    api.put('/bot-limite-cotacao/config', payload);

export const aprovarBloqueioCotacao = (id, payload = {}) =>
    api.post(`/bot-limite-cotacao/bloqueios/${id}/aprovar`, payload);

export const manterBloqueioCotacao = (id, payload = {}) =>
    api.post(`/bot-limite-cotacao/bloqueios/${id}/manter`, payload);

export const isentarContatoCotacao = (payload) =>
    api.post('/bot-limite-cotacao/isentar', payload);

export const bloquearContatoCotacao = (payload) =>
    api.post('/bot-limite-cotacao/bloquear', payload);

// ── Teste A/B de modelo do bot (tela /bot-teste-ab, só admins) ──
export const getBotAbTestes = () =>
    api.get('/bot-atendimento/ab-testes');

export const getBotAbResultado = (id) =>
    api.get(`/bot-atendimento/ab-testes/${id}/resultado`);

export const iniciarBotAbTeste = (payload) =>
    api.post('/bot-atendimento/ab-testes', payload);

export const encerrarBotAbTeste = (id) =>
    api.post(`/bot-atendimento/ab-testes/${id}/encerrar`);

// ── Compra Inteligente (análise pós-venda, só admins) ─────────
export const getCompraInteligenteDashboard = (params = {}) =>
    api.get('/compra-inteligente/dashboard', { params });

export const getCompraInteligenteAnalises = (params = {}) =>
    api.get('/compra-inteligente/analises', { params });

export const getCompraInteligenteAnalise = (id) =>
    api.get(`/compra-inteligente/analises/${id}`);

export const reanalisarCompraInteligente = (id) =>
    api.post(`/compra-inteligente/analises/${id}/reanalisar`);

export const analisarVendaCompraInteligente = (vendaId) =>
    api.post('/compra-inteligente/analisar-venda', { venda_id: vendaId });

export const atualizarConfigCompraInteligente = (dados) =>
    api.put('/compra-inteligente/config', dados);

// ── Bot de Ligação por voz (OpenAI Realtime) ──────────────────
export const getBotLigacao = () =>
    api.get('/bot-ligacao');

export const updateBotLigacaoConfig = (payload) =>
    api.put('/bot-ligacao/config', payload);

// ── URA do telefone (PABX próprio) ─────────────────────────────
export const getUra = () =>
    api.get('/pbx/ura');

export const updateUra = (payload) =>
    api.put('/pbx/ura', payload);

// O fluxo desenhado. Salvar mexe só no RASCUNHO; quem atende telefone é o
// publicado — por isso publicar é uma chamada separada, que valida antes.
export const salvarFluxoUra = (payload) =>
    api.put('/pbx/ura/fluxo', payload);

export const validarFluxoUra = (payload) =>
    api.post('/pbx/ura/validar', payload);

// Publicar gera os áudios que faltam; por isso o timeout longo.
export const publicarFluxoUra = () =>
    api.post('/pbx/ura/publicar', {}, { timeout: 300000 });

export const novoRascunhoUra = (payload) =>
    api.post('/pbx/ura/rascunho', payload);

export const versoesUra = () =>
    api.get('/pbx/ura/versoes');

export const republicarUra = (id) =>
    api.post(`/pbx/ura/versoes/${id}/republicar`, {}, { timeout: 300000 });

/* ---- Por onde as ligações andaram (abas Painel e Ligações da tela /ura) ---- */

// Aceita data_inicio, data_fim, desfecho, digito, no, q, com_gravacao, page e
// per_page. Devolve o paginador do Laravel.
export const historicoUra = (params = {}) =>
    api.get('/pbx/ura/historico', { params });

export const detalheHistoricoUra = (id) =>
    api.get(`/pbx/ura/historico/${id}`);

// A rota do áudio é autenticada como todas as outras, então a URL não serve
// direto no <audio src>: vem como blob e o player toca o objeto local.
export const audioHistoricoUra = async (id) => {
    try {
        const res = await api.get(`/pbx/ura/historico/${id}/audio`, { responseType: 'blob', timeout: 120000 });
        return res.data;
    } catch (e) {
        return null;
    }
};

export const painelUra = (params = {}) =>
    api.get('/pbx/ura/painel', { params });

// Gera os áudios que faltam ou cujo texto mudou. Demora alguns segundos por
// áudio (é TTS), por isso o timeout próprio.
export const gerarAudiosUra = (payload = {}) =>
    api.post('/pbx/ura/audios', payload, { timeout: 180000 });

// O .wav para ouvir no navegador (o .ulaw é o que vai pro telefone). Vem como
// blob porque a rota é autenticada: <audio src="..."> não manda o token.
export const baixarAudioUra = (nome) =>
    api.get(`/pbx/ura/audios/${encodeURIComponent(nome)}`, { responseType: 'blob' });

// ── Bot de Perguntas do Mercado Livre ──────────────────────────
export const getBotPerguntasMl = () =>
    api.get('/bot-perguntas-ml');

export const updateBotPerguntasMlConfig = (payload) =>
    api.put('/bot-perguntas-ml/config', payload);

// ── Follow-up pós-venda (template oficial pela Poli) ───────────
export const getPosVenda = (params = {}) =>
    api.get('/pos-venda', { params });

export const updatePosVendaConfig = (payload) =>
    api.put('/pos-venda/config', payload);

export const getPosVendaPrevia = () =>
    api.get('/pos-venda/previa');

export const getPosVendaTemplates = () =>
    api.get('/pos-venda/templates');

export const dispararPosVenda = (payload = {}) =>
    api.post('/pos-venda/disparar', payload);

// ── Retirar atrasos do Mercado Livre (agente automatiza_retira_atraso) ──
export const getRetiraAtraso = () =>
    api.get('/retira-atraso');

export const updateRetiraAtrasoConfig = (payload) =>
    api.put('/retira-atraso/config', payload);

export const rodarRetiraAtrasoAgora = () =>
    api.post('/retira-atraso/rodar-agora');

export const criarRetiraAtrasoArgumento = (payload) =>
    api.post('/retira-atraso/argumentos', payload);

export const atualizarRetiraAtrasoArgumento = (id, payload) =>
    api.put(`/retira-atraso/argumentos/${id}`, payload);

export const removerRetiraAtrasoArgumento = (id) =>
    api.delete(`/retira-atraso/argumentos/${id}`);

export const getRetiraAtrasoNegociacao = (id) =>
    api.get(`/retira-atraso/negociacoes/${id}`);

export const aprovarRetiraAtrasoNegociacao = (id, payload = {}) =>
    api.post(`/retira-atraso/negociacoes/${id}/aprovar`, payload);

export const negarRetiraAtrasoNegociacao = (id, payload = {}) =>
    api.post(`/retira-atraso/negociacoes/${id}/negar`, payload);

// CSV com as conversas do período (params: { de, ate } em YYYY-MM-DD).
export const exportarRetiraAtrasoConversas = (params) =>
    api.get('/retira-atraso/exportar', { params, responseType: 'blob' });


// ── Solicitações de tarefa humana (abertas pelo bot) ──────────
export const getSolicitacoes = async (params = {}) => {
    try { const r = await api.get('/solicitacoes', { params }); return r.data; } catch { return false; }
};
export const getSolicitacao = async (id) => {
    try { const r = await api.get(`/solicitacoes/${id}`); return r.data; } catch { return false; }
};
export const moverSolicitacao = async (id, para) => {
    try { const r = await api.post(`/solicitacoes/${id}/mover`, { para }); return r.data; } catch { return false; }
};
export const marcarSolicitacaoEntregue = async (id) => {
    try { const r = await api.post(`/solicitacoes/${id}/marcar-entregue`); return r.data; } catch { return false; }
};
export const resolverSolicitacao = async (id, formData) => {
    try { const r = await api.post(`/solicitacoes/${id}/resolver`, formData); return r.data; } catch { return false; }
};
export const recusarSolicitacao = async (id, payload) => {
    try { const r = await api.post(`/solicitacoes/${id}/recusar`, payload); return r.data; } catch { return false; }
};
export const cancelarSolicitacao = async (id) => {
    try { const r = await api.post(`/solicitacoes/${id}/cancelar`); return r.data; } catch { return false; }
};
export const resolverDiretoSolicitacao = async (id, payload = {}) => {
    try { const r = await api.post(`/solicitacoes/${id}/resolver-direto`, payload); return r.data; } catch { return false; }
};
export const reenviarNotificacaoSolicitacao = async (id) => {
    try { const r = await api.post(`/solicitacoes/${id}/reenviar-notificacao`); return r.data; } catch { return false; }
};
export const getSolicitacaoDestinos = async () => {
    try { const r = await api.get('/solicitacoes/destinos'); return r.data; } catch { return false; }
};
export const salvarSolicitacaoDestino = async (payload, id = null) => {
    try {
        const r = id
            ? await api.put(`/solicitacoes/destinos/${id}`, payload)
            : await api.post('/solicitacoes/destinos', payload);
        return r.data;
    } catch { return false; }
};
export const removerSolicitacaoDestino = async (id) => {
    try { const r = await api.delete(`/solicitacoes/destinos/${id}`); return r.data; } catch { return false; }
};

// ───────────────────────────── CRM ─────────────────────────────
export const getCrmContatos = async (params) => {
    try { const r = await api.get('/crm/contatos', { params }); return r.data; } catch { return false; }
};
export const criarCrmContato = async (data) => {
    try { const r = await api.post('/crm/contatos', data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const getCrmContato = async (id) => {
    try { const r = await api.get(`/crm/contatos/${id}`); return r.data; } catch { return false; }
};
export const atualizarCrmContato = async (id, data) => {
    try { const r = await api.put(`/crm/contatos/${id}`, data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const getCrmMensagens = async (id, params) => {
    try { const r = await api.get(`/crm/contatos/${id}/mensagens`, { params }); return r.data; } catch { return false; }
};
export const getCrmMensagensPoli = async (id) => {
    try { const r = await api.get(`/crm/contatos/${id}/mensagens-poli`); return r.data; } catch { return false; }
};
export const enviarCrmMensagem = async (id, data) => {
    try {
        const isForm = (typeof FormData !== 'undefined') && data instanceof FormData;
        const r = await api.post(`/crm/contatos/${id}/mensagens`, data,
            isForm ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined);
        return r.data;
    } catch (e) { return e.response?.data || false; }
};
export const marcarCrmLido = async (id) => {
    try { const r = await api.put(`/crm/contatos/${id}/lido`); return r.data; } catch { return false; }
};
export const addCrmVeiculo = async (id, data) => {
    try { const r = await api.post(`/crm/contatos/${id}/veiculos`, data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const removerCrmVeiculo = async (id, vid) => {
    try { const r = await api.delete(`/crm/contatos/${id}/veiculos/${vid}`); return r.data; } catch { return false; }
};
// Veículo da CONTA (veio de uma compra do site, sem contato de chat).
export const removerCrmVeiculoConta = async (clienteId, vid) => {
    try { const r = await api.delete(`/crm/carteira/${clienteId}/veiculos/${vid}`); return r.data; } catch { return false; }
};
export const addCrmTag = async (id, tag) => {
    try { const r = await api.post(`/crm/contatos/${id}/tags`, { tag }); return r.data; } catch (e) { return e.response?.data || false; }
};
export const removerCrmTag = async (id, tagId) => {
    try { const r = await api.delete(`/crm/contatos/${id}/tags/${tagId}`); return r.data; } catch { return false; }
};
export const getCrmOportunidades = async (params) => {
    try { const r = await api.get('/crm/oportunidades', { params }); return r.data; } catch { return false; }
};
export const getCrmConfig = async () => {
    try { const r = await api.get('/crm/config'); return r.data; } catch { return false; }
};
export const salvarCrmConfig = async (data) => {
    try { const r = await api.put('/crm/config', data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const getCrmStats = async (params) => {
    try { const r = await api.get('/crm/stats', { params }); return r.data; } catch { return false; }
};
export const getCrmMinhasMetas = async (params) => {
    try { const r = await api.get('/crm/minhas-metas', { params }); return r.data; } catch { return false; }
};
export const getCrmZapiStatus = async () => {
    try { const r = await api.get('/crm/zapi/status'); return r.data; } catch { return false; }
};
export const configurarCrmWebhooks = async () => {
    try { const r = await api.post('/crm/zapi/configurar-webhooks'); return r.data; } catch (e) { return e.response?.data || false; }
};
export const atualizarCrmPerfil = async (formData) => {
    try {
        const r = await api.post('/crm/zapi/perfil', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return r.data;
    } catch (e) { return e.response?.data || false; }
};

// ── CRM · Carteira / Ficha / Tarefas (V0) ──
export const getCrmCarteira = async (params) => {
    try { const r = await api.get('/crm/carteira', { params }); return r.data; } catch { return false; }
};
export const buscarCrmClientes = async (q) => {
    try { const r = await api.get('/crm/clientes/busca', { params: { q } }); return r.data; } catch { return false; }
};
export const getCrmFicha = async (clienteId) => {
    try { const r = await api.get(`/crm/carteira/${clienteId}`); return r.data; } catch { return false; }
};
export const addCrmCarteira = async (data) => {
    try { const r = await api.post('/crm/carteira', data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const atualizarCrmCarteira = async (clienteId, data) => {
    try { const r = await api.put(`/crm/carteira/${clienteId}`, data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const trocarDonoCrmCarteira = async (clienteId, vendedorUserId) => {
    try { const r = await api.put(`/crm/carteira/${clienteId}/dono`, { vendedor_user_id: vendedorUserId }); return r.data; } catch (e) { return e.response?.data || false; }
};
export const removerCrmCarteira = async (clienteId) => {
    try { const r = await api.put(`/crm/carteira/${clienteId}/dono`, { vendedor_user_id: null }); return r.data; } catch (e) { return e.response?.data || false; }
};
export const addCrmPessoa = async (clienteId, data) => {
    try { const r = await api.post(`/crm/carteira/${clienteId}/pessoas`, data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const removerCrmPessoa = async (clienteId, pessoaId) => {
    try { const r = await api.delete(`/crm/carteira/${clienteId}/pessoas/${pessoaId}`); return r.data; } catch { return false; }
};
export const editarCrmPessoa = async (clienteId, pessoaId, data) => {
    try { const r = await api.put(`/crm/carteira/${clienteId}/pessoas/${pessoaId}`, data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const registrarCrmAtividade = async (clienteId, data) => {
    try { const r = await api.post(`/crm/carteira/${clienteId}/atividades`, data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const getCrmAtividadesLog = async (params) => {
    try { const r = await api.get('/crm/atividades', { params }); return r.data; } catch { return false; }
};
export const exportarCrmAtividades = async (params) => {
    try { const r = await api.get('/crm/atividades/exportar', { params, responseType: 'blob' }); return r.data; } catch { return false; }
};
export const getCrmTarefas = async (params) => {
    try { const r = await api.get('/crm/tarefas', { params }); return r.data; } catch { return false; }
};
export const getCrmTarefasBoard = async (params) => {
    try { const r = await api.get('/crm/tarefas/board', { params }); return r.data; } catch { return false; }
};
export const criarCrmTarefa = async (data) => {
    try { const r = await api.post('/crm/tarefas', data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const atualizarCrmTarefa = async (id, data) => {
    try { const r = await api.put(`/crm/tarefas/${id}`, data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const exportarCrmTarefas = async (params) => {
    try { const r = await api.get('/crm/tarefas/exportar', { params, responseType: 'blob' }); return r.data; } catch { return false; }
};
export const gerarCrmTarefas = async () => {
    try { const r = await api.post('/crm/tarefas/gerar'); return r.data; } catch (e) { return e.response?.data || false; }
};
// CRM · Tarefas automáticas (V1.7)
export const registrarCrmTarefaDesfecho = async (id, data) => {
    try { const r = await api.post(`/crm/tarefas/${id}/desfecho`, data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const getCrmTarefasConfig = async () => {
    try { const r = await api.get('/crm/tarefas/config'); return r.data; } catch { return false; }
};
export const salvarCrmTarefasConfig = async (data) => {
    try { const r = await api.put('/crm/tarefas/config', data); return r.data; } catch (e) { return e.response?.data || false; }
};
export const getCrmTarefasMetricas = async (params) => {
    try { const r = await api.get('/crm/tarefas/metricas', { params }); return r.data; } catch { return false; }
};
export const getCrmBase = async (params) => {
    try { const r = await api.get('/crm/base', { params }); return r.data; } catch { return false; }
};
export const getCrmFichaPorContato = async (contatoId) => {
    try { const r = await api.get(`/crm/ficha/contato/${contatoId}`); return r.data; } catch { return false; }
};

// ── Kanban de Pendências de Vendas ─────────────────────────────
export const getPendenciasVendas = async (force = false) => {
    try { const r = await api.get('/pendencias-vendas', { params: force ? { sync: 1 } : {} }); return r.data; } catch (e) { console.error('Erro ao buscar pendências de vendas:', e); return false; }
};
export const getDetalhesPendencia = async (vendaId) => {
    try { const r = await api.get(`/pendencias-vendas/${vendaId}/detalhes`); return r.data; } catch (e) { console.error('Erro ao buscar detalhes da pendência:', e); return false; }
};
export const moverEstagioPendencia = async (vendaId, estagio) => {
    try { const r = await api.put(`/pendencias-vendas/${vendaId}/estagio`, { estagio, userId: user?.id }); return r.data; } catch (e) { return e.response?.data || false; }
};
export const atribuirResponsavelPendencia = async (vendaId, responsavelUserId) => {
    try { const r = await api.put(`/pendencias-vendas/${vendaId}/responsavel`, { responsavel_user_id: responsavelUserId, userId: user?.id }); return r.data; } catch (e) { return e.response?.data || false; }
};
export const getNotasPendencia = async (vendaId) => {
    try { const r = await api.get(`/pendencias-vendas/${vendaId}/notas`); return r.data; } catch (e) { return false; }
};
export const addNotaPendencia = async (vendaId, observacao) => {
    try { const r = await api.post(`/pendencias-vendas/${vendaId}/notas`, { observacao, userId: user?.id }); return r.data; } catch (e) { return e.response?.data || false; }
};



// ---- Divergencias de preco (custo cadastrado x preco do fornecedor) ----
export const getDivergenciasPrecoOpcoes = async () => {
    try { const r = await api.get('/divergencias-preco/opcoes'); return r.data; } catch (e) { console.error('Erro ao carregar opcoes de divergencias de preco:', e); return false; }
};
export const getDivergenciasPrecoFornecedores = async (params = {}) => {
    try { const r = await api.get('/divergencias-preco/fornecedores', { params }); return r.data; } catch (e) { console.error('Erro ao carregar divergencias por fornecedor:', e); return false; }
};
export const getDivergenciasPrecoListas = async (params = {}) => {
    try { const r = await api.get('/divergencias-preco/listas', { params }); return r.data; } catch (e) { console.error('Erro ao carregar divergencias por lista:', e); return false; }
};
export const getDivergenciasPrecoItens = async (params = {}) => {
    try { const r = await api.get('/divergencias-preco/itens', { params }); return r.data; } catch (e) { console.error('Erro ao carregar divergencias item a item:', e); return false; }
};

// ---- Cobertura de Furos (Kanban de furo de estoque) ----
export const getCoberturaFuros = async (params = {}) => {
    try { const r = await api.get('/furo-kanban', { params }); return r.data; } catch (e) { console.error('Erro ao carregar cobertura de furos:', e); return false; }
};
export const getDetalheFuro = async (id) => {
    try { const r = await api.get(`/furo-kanban/furos/${id}`); return r.data; } catch (e) { console.error('Erro ao carregar detalhe do furo:', e); return false; }
};
// ofertas = ids marcados como capazes de suprir; omitido mantém a seleção atual.
export const moverFuroEstagio = async (id, estagio, ofertas) => {
    const payload = ofertas === undefined ? { estagio } : { estagio, ofertas };
    try { const r = await api.put(`/furo-kanban/furos/${id}/estagio`, payload); return r.data; } catch (e) { return e.response?.data || false; }
};
export const gerarPedidosFuro = async () => {
    try { const r = await api.post('/furo-kanban/gerar-pedidos'); return r.data; } catch (e) { return e.response?.data || false; }
};
export const atualizarPedidoFuro = async (id, payload) => {
    try { const r = await api.put(`/furo-kanban/pedidos/${id}`, payload); return r.data; } catch (e) { return e.response?.data || false; }
};
export const excluirPedidoFuro = async (id) => {
    try { const r = await api.delete(`/furo-kanban/pedidos/${id}`); return r.data; } catch (e) { return e.response?.data || false; }
};
export const adicionarItemPedidoFuro = async (id, respostaItemId) => {
    try { const r = await api.post(`/furo-kanban/pedidos/${id}/itens`, { resposta_item_id: respostaItemId }); return r.data; } catch (e) { return e.response?.data || false; }
};
export const formalizarPedidoFuro = async (id) => {
    try { const r = await api.post(`/furo-kanban/pedidos/${id}/formalizar`); return r.data; } catch (e) { return e.response?.data || false; }
};
// Última etapa: mercadoria retirada no fornecedor. Chamar de novo só atualiza rastreio/observação.
export const marcarPedidoFuroRetirado = async (id, payload) => {
    try { const r = await api.post(`/furo-kanban/pedidos/${id}/retirado`, payload); return r.data; } catch (e) { return e.response?.data || false; }
};
// Volta o pedido para "Formalizados, a retirar" e apaga rastreio e observação da retirada.
export const desfazerPedidoFuroRetirado = async (id) => {
    try { const r = await api.post(`/furo-kanban/pedidos/${id}/desfazer-retirado`); return r.data; } catch (e) { return e.response?.data || false; }
};
export const atualizarItemPedidoFuro = async (itemId, payload) => {
    try { const r = await api.put(`/furo-kanban/itens/${itemId}`, payload); return r.data; } catch (e) { return e.response?.data || false; }
};
export const removerItemPedidoFuro = async (itemId) => {
    try { const r = await api.delete(`/furo-kanban/itens/${itemId}`); return r.data; } catch (e) { return e.response?.data || false; }
};

/* ---------------------------------------------------------------------------
 * Devolução a Fornecedor (NF-e de devolução)
 * ------------------------------------------------------------------------- */

export const getDevolucoesFornecedor = async (params = {}) => {
    try {
        const res = await api.get('/devolucoes_fornecedor', { params });
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const getPerfisDevolucaoFornecedor = async () => {
    try {
        const res = await api.get('/devolucoes_fornecedor/perfis');
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

/** Lê a NF-e de compra: XML colado, arquivo enviado ou chave consultada. */
export const lerNotaCompraDevolucao = async (payload) => {
    try {
        let res;
        if (payload instanceof FormData) {
            res = await api.post('/devolucoes_fornecedor/ler-nota-compra', payload, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
        } else {
            res = await api.post('/devolucoes_fornecedor/ler-nota-compra', payload);
        }
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

/**
 * Lê o PDF da autorização antes de o rascunho existir: devolve os campos extraídos
 * e um token do arquivo, que volta em criarDevolucaoFornecedor para anexar o mesmo
 * PDF sem pagar a leitura de novo.
 */
export const lerAutorizacaoDevolucao = async (arquivo, perfil) => {
    try {
        const form = new FormData();
        form.append('arquivo', arquivo);
        if (perfil) form.append('perfil', perfil);
        const res = await api.post('/devolucoes_fornecedor/ler-autorizacao', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const criarDevolucaoFornecedor = async (payload) => {
    try {
        const res = await api.post('/devolucoes_fornecedor', payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const getDevolucaoFornecedor = async (id) => {
    try {
        const res = await api.get(`/devolucoes_fornecedor/${id}`);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const atualizarDevolucaoFornecedor = async (id, payload) => {
    try {
        const res = await api.put(`/devolucoes_fornecedor/${id}`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const removerItemDevolucaoFornecedor = async (id, itemId) => {
    try {
        const res = await api.delete(`/devolucoes_fornecedor/${id}/itens/${itemId}`);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const enviarAutorizacaoDevolucaoFornecedor = async (id, arquivo) => {
    try {
        const form = new FormData();
        form.append('arquivo', arquivo);
        const res = await api.post(`/devolucoes_fornecedor/${id}/autorizacao`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const validarDevolucaoFornecedor = async (id) => {
    try {
        const res = await api.post(`/devolucoes_fornecedor/${id}/validar`);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

/** ambiente: 'producao' emite a nota de verdade; 'homologacao' e teste sem valor fiscal. */
export const emitirDevolucaoFornecedor = async (id, ambiente = 'producao') => {
    try {
        const res = await api.post(`/devolucoes_fornecedor/${id}/emitir`, { ambiente });
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const alterarStatusDevolucaoFornecedor = async (id, payload) => {
    try {
        const res = await api.post(`/devolucoes_fornecedor/${id}/status`, payload);
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const cancelarDevolucaoFornecedor = async (id, justificativa) => {
    try {
        const res = await api.post(`/devolucoes_fornecedor/${id}/cancelar`, { justificativa });
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

/** XML e DANFE saem como download direto (blob). teste = arquivo da emissao em homologacao. */
export const baixarArquivoDevolucaoFornecedor = async (id, tipo, teste = false) => {
    try {
        const res = await api.get(`/devolucoes_fornecedor/${id}/${tipo}`, {
            params: teste ? { teste: 1 } : {},
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download',
            `devolucao${teste ? '_homologacao' : ''}_${id}.${tipo === 'xml' ? 'xml' : 'pdf'}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { sucesso: true };
    } catch (err) {
        return { error: err.response?.data?.error || err.message };
    }
};

// --- NF-e de devolução emitida no recebimento (#2225) ---

// 422 de validação do Laravel vem como {message, errors}, sem a chave error que
// as telas conferem: sem isso, salvar com campo inválido aparecia como sucesso.
const erroNotaDevolucao = (err) => {
    const data = err.response?.data;
    if (!data || typeof data !== "object") return { error: err.message };
    const primeiro = data.errors ? Object.values(data.errors).flat()[0] : null;
    return { ...data, error: data.error || primeiro || data.message || err.message };
};

export const getNotasDevolucaoVenda = async (params = {}) => {
    try {
        const res = await api.get('/devolucoes_venda_nfe', { params });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const getNotaDevolucaoVenda = async (id) => {
    try {
        const res = await api.get(`/devolucoes_venda_nfe/${id}`);
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

/** Usado pelo card da devolução em /devolucoes: pode não existir registro ainda. */
export const getNotaDevolucaoPorDevolucao = async (devolucaoId) => {
    try {
        const res = await api.get(`/devolucoes_venda_nfe/por-devolucao/${devolucaoId}`);
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const confirmarNotaClienteDevolucao = async (id, chave) => {
    try {
        const res = await api.post(`/devolucoes_venda_nfe/${id}/confirmar-nota-cliente`, { chave, userId: user?.id });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const descartarNotasClienteDevolucao = async (id) => {
    try {
        const res = await api.post(`/devolucoes_venda_nfe/${id}/descartar-notas-cliente`, { userId: user?.id });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

/** Gera a nota de uma devolução já recebida, sem mexer no recebimento. */
export const gerarNotaDevolucaoParaDevolucao = async (devolucaoId, marcacoes = {}) => {
    try {
        const res = await api.post(`/devolucoes_venda_nfe/gerar/${devolucaoId}`, { ...marcacoes, userId: user?.id });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const reprocessarNotaDevolucaoVenda = async (id) => {
    try {
        const res = await api.post(`/devolucoes_venda_nfe/${id}/reprocessar`, { userId: user?.id });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

/** XML e DANFE saem como download direto (blob). */
export const baixarArquivoNotaDevolucaoVenda = async (id, tipo) => {
    try {
        const res = await api.get(`/devolucoes_venda_nfe/${id}/${tipo}`, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `devolucao_venda_${id}.${tipo === 'xml' ? 'xml' : 'pdf'}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { sucesso: true };
    } catch (err) {
        return { error: err.response?.data?.error || err.message };
    }
};

export const baixarNotaClienteDevolucao = async (id, formato) => {
    try {
        const res = await api.get(`/devolucoes_venda_nfe/${id}/nota-cliente/${formato}`, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `nota_cliente_${id}.${formato === 'xml' ? 'xml' : 'pdf'}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { sucesso: true };
    } catch (err) {
        // Erro vem como blob por causa do responseType: sem ler o texto, a tela
        // mostraria "[object Blob]" no lugar do motivo.
        let mensagem = err.message;
        try {
            const texto = await err.response?.data?.text?.();
            if (texto) { mensagem = JSON.parse(texto)?.error || mensagem; }
        } catch (_) { /* mantem a mensagem original */ }
        return { error: mensagem };
    }
};

export const getConfigNotaDevolucao = async () => {
    try {
        const res = await api.get('/devolucoes_venda_nfe/configuracao');
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const salvarConfigNotaDevolucao = async (payload) => {
    try {
        const res = await api.put('/devolucoes_venda_nfe/configuracao', { ...payload, userId: user?.id });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const salvarMarcacoesNotaDevolucao = async (id, marcacoes) => {
    try {
        const res = await api.put(`/devolucoes_venda_nfe/${id}/marcacoes`, { ...marcacoes, userId: user?.id });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const gerarNotaDevolucaoParaVenda = async (vendaId, marcacoes = {}) => {
    try {
        const res = await api.post(`/devolucoes_venda_nfe/gerar-venda/${vendaId}`, { ...marcacoes, userId: user?.id });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const getDifalDevolucoes = async (params = {}) => {
    try {
        const res = await api.get('/devolucoes_venda_nfe/difal', { params });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const baixarDifalDevolucoesCsv = async (params = {}) => {
    try {
        const res = await api.get('/devolucoes_venda_nfe/difal', { params: { ...params, formato: 'csv' }, responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'difal_devolucoes.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { sucesso: true };
    } catch (err) {
        return { error: err.response?.data?.error || err.message };
    }
};

export const getFilaVendasCanceladas = async (params = {}) => {
    try {
        const res = await api.get('/nfe_vendas_canceladas', { params });
        return res.data;
    } catch (err) {
        return erroNotaDevolucao(err);
    }
};

export const decidirFilaVendaCancelada = async (id, acao, observacao = '') => {
    try {
        const res = await api.post(`/nfe_vendas_canceladas/${id}/decisao`, { acao, observacao, userId: user?.id });
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

export const consultarFilaVendaCancelada = async (id) => {
    try {
        const res = await api.post(`/nfe_vendas_canceladas/${id}/consultar`, { userId: user?.id });
        return res.data;
    } catch (err) {
        return err.response?.data || { error: err.message };
    }
};

// --- Dimensões: banco, suspeitos, famílias, logs, placar e simulador ---

export const getDimensoesBanco = async (params) => {
    const res = await api.get('/dimensoes/banco', { params });
    return res.data;
};

export const getDimensoesSuspeitos = async (params) => {
    const res = await api.get('/dimensoes/suspeitos', { params });
    return res.data;
};

export const getDimensoesPlacar = async () => {
    const res = await api.get('/dimensoes/placar');
    return res.data;
};

export const getDimensoesLogs = async (params) => {
    const res = await api.get('/dimensoes/logs', { params });
    return res.data;
};

export const getDimensoesCotacoes = async (params) => {
    const res = await api.get('/dimensoes/cotacoes', { params });
    return res.data;
};

export const getDimensoesConferencia = async (params) => {
    const res = await api.get('/dimensoes/conferencia', { params });
    return res.data;
};

export const simularDimensao = async (sku) => {
    const res = await api.get('/dimensoes/simular', { params: { sku } });
    return res.data;
};

export const medirDimensao = async (id, dados) => {
    const res = await api.put(`/dimensoes/produto/${id}/medir`, dados);
    return res.data;
};

export const getDimensaoFamilias = async (params) => {
    const res = await api.get('/dimensoes/familias', { params });
    return res.data;
};

export const salvarDimensaoFamilia = async (id, dados) => {
    const res = id
        ? await api.put(`/dimensoes/familias/${id}`, dados)
        : await api.post('/dimensoes/familias', dados);
    return res.data;
};

export const previaDimensaoFamilia = async (dados) => {
    const res = await api.post('/dimensoes/familias/previa', dados);
    return res.data;
};

export const getProdutosDaFamilia = async (id, params) => {
    const res = await api.get(`/dimensoes/familias/${id}/produtos`, { params });
    return res.data;
};

export const vincularProdutoFamilia = async (id, dados) => {
    const res = await api.post(`/dimensoes/familias/${id}/produtos`, dados);
    return res.data;
};

export const removerVinculoFamilia = async (id, produtoId) => {
    const res = await api.delete(`/dimensoes/familias/${id}/produtos/${produtoId}`);
    return res.data;
};

export const getDimensaoConfig = async () => {
    const res = await api.get('/dimensoes/configuracoes');
    return res.data;
};

export const salvarDimensaoConfig = async (config) => {
    const res = await api.put('/dimensoes/configuracoes', { config });
    return res.data;
};

export const getLalamoveServicos = async () => {
    const res = await api.get('/lalamove/servicos');
    return res.data;
};

// Sem venda o backend devolve o esqueleto da corrida avulsa: mesmo endpoint,
// mesmo fluxo, so sem venda para vincular.
export const prepararLalamove = async (vendaId) => {
    const res = await api.post('/lalamove/preparar', vendaId ? { venda_id: vendaId } : {});
    return res.data;
};

export const cotarLalamove = async (payload) => {
    const res = await api.post('/lalamove/cotar', payload);
    return res.data;
};

export const trocarMotoristaLalamove = async (alvo, motivo) => {
    const res = await api.post('/lalamove/trocar-motorista', { ...alvoDaCorrida(alvo), motivo });
    return res.data;
};

export const buscarEnderecoLalamove = async (q) => {
    const res = await api.get('/lalamove/endereco/buscar', { params: { q } });
    return res.data;
};

export const enderecoPorPontoLalamove = async (lat, lng) => {
    const res = await api.get('/lalamove/endereco/ponto', { params: { lat, lng } });
    return res.data;
};

export const cotarModalidadeLalamove = async (payload) => {
    const res = await api.post('/lalamove/cotar-modalidade', payload);
    return res.data;
};

export const criarOrdemLalamove = async (payload) => {
    const res = await api.post('/lalamove/criar-ordem', payload);
    return res.data;
};

/**
 * Aponta a corrida pela venda (fluxo de despacho) ou pelo id da propria ordem
 * (corrida avulsa, que nao tem venda para apontar).
 */
const alvoDaCorrida = (alvo) => (
    typeof alvo === 'object' && alvo !== null
        ? { venda_id: alvo.vendaId ?? undefined, ordem_id: alvo.ordemId ?? undefined }
        : { venda_id: alvo }
);

export const getOrdemLalamove = async (vendaId, atualizar = false) => {
    const res = await api.get(`/lalamove/ordem/${vendaId}`, { params: atualizar ? { atualizar: 1 } : {} });
    return res.data;
};

export const getCorridaLalamove = async (ordemId, atualizar = false) => {
    const res = await api.get(`/lalamove/corrida/${ordemId}`, { params: atualizar ? { atualizar: 1 } : {} });
    return res.data;
};

export const buscarVendasLalamove = async (q) => {
    const res = await api.get('/lalamove/buscar-vendas', { params: { q } });
    return res.data;
};

// serviceType e opcional: a Lalamove nao devolve a modalidade de corrida criada
// no portal dela, entao quem sabe e o operador que esta olhando aquela tela.
export const importarCorridaLalamove = async (orderId, vendaId, serviceType) => {
    const res = await api.post('/lalamove/importar', {
        order_id: orderId,
        venda_id: vendaId || undefined,
        service_type: serviceType || undefined,
    });
    return res.data;
};

// Adianta a gorjeta para o proximo degrau, sem esperar o intervalo.
export const aumentarGorjetaAgoraLalamove = async (alvo) => {
    const res = await api.post('/lalamove/aumentar-agora', alvoDaCorrida(alvo));
    return res.data;
};

// Para (pausar=true) ou retoma o aumento automatico da gorjeta de uma corrida.
export const pausarAumentoGorjetaLalamove = async (alvo, pausar) => {
    const res = await api.post('/lalamove/pausar-aumento', { ...alvoDaCorrida(alvo), pausar });
    return res.data;
};

export const descartarPendenteLalamove = async (alvo) => {
    const res = await api.post('/lalamove/descartar-pendente', alvoDaCorrida(alvo));
    return res.data;
};

export const cancelarOrdemLalamove = async (alvo, motivo) => {
    const res = await api.post('/lalamove/cancelar', { ...alvoDaCorrida(alvo), motivo });
    return res.data;
};

export const getCorridasLalamove = async (params = {}) => {
    const res = await api.get('/lalamove/corridas', { params });
    return res.data;
};

export const getLogsLalamove = async (params = {}) => {
    const res = await api.get('/lalamove/logs', { params });
    return res.data;
};

export const getConfiguracaoLalamove = async () => {
    const res = await api.get('/lalamove/configuracao');
    return res.data;
};

export const salvarConfiguracaoLalamove = async (payload) => {
    const res = await api.put('/lalamove/configuracao', payload);
    return res.data;
};

export const testarConexaoLalamove = async () => {
    const res = await api.post('/lalamove/testar-conexao');
    return res.data;
};

export const registrarWebhookLalamove = async () => {
    const res = await api.post('/lalamove/webhook/registrar');
    return res.data;
};

// ── Lalamove: coleta de compra no fornecedor (#2307) ───────────────
export const getPontosColetaLalamove = async () => {
    const res = await api.get('/lalamove/pontos-coleta');
    return res.data;
};

export const salvarPontoColetaLalamove = async (id, payload) => {
    const res = id
        ? await api.put(`/lalamove/pontos-coleta/${id}`, payload)
        : await api.post('/lalamove/pontos-coleta', payload);
    return res.data;
};

export const alternarPontoColetaLalamove = async (id, ativo) => {
    const res = await api.post(`/lalamove/pontos-coleta/${id}/ativo`, { ativo });
    return res.data;
};

export const prepararColetaLalamove = async (params) => {
    const res = await api.post('/lalamove/coleta/preparar', params);
    return res.data;
};

export const cotarColetaLalamove = async (payload) => {
    const res = await api.post('/lalamove/coleta/cotar', payload);
    return res.data;
};

export const cotarModalidadeColetaLalamove = async (payload) => {
    const res = await api.post('/lalamove/coleta/cotar-modalidade', payload);
    return res.data;
};

export const criarColetaLalamove = async (payload) => {
    const res = await api.post('/lalamove/coleta/criar-ordem', payload);
    return res.data;
};

export const getCorridaColetaLalamove = async (ordemId, atualizar = false) => {
    const res = await api.get(`/lalamove/coleta/corrida/${ordemId}`, { params: atualizar ? { atualizar: 1 } : {} });
    return res.data;
};

export const buscarComprasColetaLalamove = async (q, tipo) => {
    const res = await api.get('/lalamove/coleta/compras', { params: { q, tipo: tipo || undefined } });
    return res.data;
};

export const vincularComprasColetaLalamove = async (payload) => {
    const res = await api.post('/lalamove/coleta/vincular', payload);
    return res.data;
};

export const desvincularCompraColetaLalamove = async (vinculoId) => {
    const res = await api.post('/lalamove/coleta/desvincular', { vinculo_id: vinculoId });
    return res.data;
};

// ── Cotações por E-mail (bot da caixa vendas@) ─────────────────────
export const getCotacoesEmail = (params = {}) =>
    api.get('/cotacoes-email', { params });
export const getCotacaoEmail = (id) =>
    api.get(`/cotacoes-email/${id}`);
export const getCotacoesEmailDashboard = (params = {}) =>
    api.get('/cotacoes-email/dashboard', { params });
export const getCotacoesEmailConfig = () =>
    api.get('/cotacoes-email/config');
export const atualizarCotacoesEmailConfig = (dados) =>
    api.put('/cotacoes-email/config', dados);
export const testarConexaoCotacoesEmail = () =>
    api.post('/cotacoes-email/testar-conexao');
export const pollAgoraCotacoesEmail = () =>
    api.post('/cotacoes-email/poll-agora');
export const getCotacoesEmailIgnorados = (params = {}) =>
    api.get('/cotacoes-email/ignorados', { params });
export const promoverCotacaoEmailIgnorado = (msgId) =>
    api.post(`/cotacoes-email/ignorados/${msgId}/promover`);
export const acaoCotacaoEmail = (id, acao, dados = {}) =>
    api.post(`/cotacoes-email/${id}/${acao}`, dados);
export const enviarRascunhoCotacaoEmail = (id, msgId) =>
    api.post(`/cotacoes-email/${id}/enviar-rascunho/${msgId}`);
export const urlAnexoCotacaoEmail = (id, msgId, idx) =>
    `/cotacoes-email/${id}/anexo/${msgId}/${idx}`;
export const baixarAnexoCotacaoEmail = async (id, msgId, idx, nome = 'anexo') => {
    const response = await api.get(urlAnexoCotacaoEmail(id, msgId, idx), { responseType: 'blob' });
    const contentType = response.headers['content-type'] || '';
    return _triggerBlobDownload(response.data, contentType, nome);
};

export const getProdutosBloqueados = async (params = {}) => {
    try {
        const res = await api.get("/produtos-bloqueados", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao listar produtos bloqueados:", error);
        return null;
    }
};

export const getResumoProdutosBloqueados = async () => {
    try {
        const res = await api.get("/produtos-bloqueados/resumo");
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar o resumo de produtos bloqueados:", error);
        return null;
    }
};

export const getHistoricoBloqueio = async (produtoId) => {
    try {
        const res = await api.get(`/produtos-bloqueados/${produtoId}/historico`);
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar o historico de bloqueio:", error);
        return null;
    }
};

// Consulta de estoque ao fornecedor titular de produto bloqueado.
// A criacao exige login; as tres de baixo sao a pagina do fornecedor, que abre
// pelo hash, sem token, e por isso usam axios direto.
export const criarConsultaEstoque = async (payload) => {
    try {
        const res = await api.post("/consultas-estoque", payload);
        return res.data;
    } catch (error) {
        console.error("Erro ao criar a consulta de estoque:", error);
        return { erro: error?.response?.data?.message || "Não foi possível gerar a consulta." };
    }
};

export const buscarConsultaEstoquePorHash = async (hash) => {
    try {
        const res = await axios.get(`${baseUrlApi}/consultas-estoque/public/${hash}`);
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar a consulta de estoque:", error);
        return null;
    }
};

export const responderConsultaEstoque = async (hash, payload) => {
    try {
        const res = await axios.post(`${baseUrlApi}/consultas-estoque/public/${hash}/responder`, payload);
        return res.data;
    } catch (error) {
        console.error("Erro ao responder a consulta de estoque:", error);
        return { erro: error?.response?.data?.message || "Não foi possível registrar a resposta." };
    }
};

export const finalizarConsultaEstoque = async (hash) => {
    try {
        const res = await axios.post(`${baseUrlApi}/consultas-estoque/public/${hash}/finalizar`);
        return res.data;
    } catch (error) {
        console.error("Erro ao finalizar a consulta de estoque:", error);
        return { erro: error?.response?.data?.message || "Não foi possível enviar as respostas." };
    }
};

export const listarConsultasEstoque = async (params) => {
    try {
        const res = await api.get("/consultas-estoque", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao listar as consultas de estoque:", error);
        return null;
    }
};

export const getConsultaEstoque = async (id) => {
    try {
        const res = await api.get(`/consultas-estoque/${id}`);
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar a consulta de estoque:", error);
        return null;
    }
};

export const getConfigConsultaEstoque = async () => {
    try {
        const res = await api.get("/consultas-estoque/configuracao");
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar a configuração da consulta de estoque:", error);
        return null;
    }
};

// Propaga o erro em vez de devolver null: a tela precisa da mensagem do 422
// para dizer qual parâmetro saiu da faixa, e do 403 para dizer que só
// administrador salva.
export const salvarConfigConsultaEstoque = async (config) => {
    const res = await api.put("/consultas-estoque/configuracao", config);
    return res.data;
};

/* Compras de Fábrica (pedido semanal com mínimo + prazo automático no ML) */
export const getComprasFabrica = async () => {
    try {
        const res = await api.get("/compras-fabrica");
        return res.data;
    } catch (error) {
        console.error("Erro ao listar fornecedores de fábrica:", error);
        return null;
    }
};

export const getCompraFabrica = async (fornecedorId) => {
    try {
        const res = await api.get(`/compras-fabrica/${fornecedorId}`);
        return res.data;
    } catch (error) {
        console.error("Erro ao buscar a configuração de compra de fábrica:", error);
        return null;
    }
};

export const updateCompraFabrica = async (fornecedorId, dados) => {
    const res = await api.put(`/compras-fabrica/${fornecedorId}`, dados);
    return res.data;
};

export const getCompraFabricaPrevia = async (fornecedorId) => {
    try {
        const res = await api.get(`/compras-fabrica/${fornecedorId}/previa`);
        return res.data;
    } catch (error) {
        console.error("Erro ao montar a prévia do pedido de fábrica:", error);
        return null;
    }
};

/* Publicidade ML (Product Ads: campanhas, anúncios e regras automáticas) */
export const getMlAdsOpcoes = async () => {
    try {
        const res = await api.get("/ml-ads/opcoes");
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar opções da publicidade ML:", error);
        return null;
    }
};

export const getMlAdsPainel = async (params = {}) => {
    try {
        const res = await api.get("/ml-ads/painel", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar o painel de campanhas:", error);
        return null;
    }
};

export const getMlAdsAnuncios = async (params = {}) => {
    try {
        const res = await api.get("/ml-ads/anuncios", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar os anúncios da publicidade:", error);
        return null;
    }
};

export const getMlAdsAnuncioDiario = async (id, params = {}) => {
    try {
        const res = await api.get(`/ml-ads/anuncios/${id}/diario`, { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar o diário do anúncio:", error);
        return null;
    }
};

export const fixarMlAdsAnuncio = async (id, fixado) => {
    const res = await api.post(`/ml-ads/anuncios/${id}/fixar`, { fixado });
    return res.data;
};

export const getMlAdsRegras = async () => {
    try {
        const res = await api.get("/ml-ads/regras");
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar as regras da publicidade:", error);
        return null;
    }
};

export const salvarMlAdsRegra = async (regra) => {
    const res = regra.id
        ? await api.put(`/ml-ads/regras/${regra.id}`, regra)
        : await api.post("/ml-ads/regras", regra);
    return res.data;
};

export const excluirMlAdsRegra = async (id) => {
    const res = await api.delete(`/ml-ads/regras/${id}`);
    return res.data;
};

/** Regra salva (id) ou o formulário ainda não salvo (objeto). */
export const simularMlAdsRegra = async (regraOuId) => {
    const res = typeof regraOuId === "object"
        ? await api.post("/ml-ads/regras/simular", regraOuId)
        : await api.post(`/ml-ads/regras/${regraOuId}/simular`);
    return res.data;
};

export const aplicarMlAdsRegra = async (id) => {
    const res = await api.post(`/ml-ads/regras/${id}/aplicar`);
    return res.data;
};

export const getMlAdsAcoes = async (params = {}) => {
    try {
        const res = await api.get("/ml-ads/acoes", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar o histórico da publicidade:", error);
        return null;
    }
};

export const criarMlAdsCampanha = async (dados) => {
    const res = await api.post("/ml-ads/campanhas", dados);
    return res.data;
};

export const editarMlAdsCampanha = async (contaId, campanhaId, dados) => {
    const res = await api.put(`/ml-ads/campanhas/${contaId}/${campanhaId}`, dados);
    return res.data;
};

/*
 * Saúde dos Anúncios ML: varredura diária das contas do Mercado Livre,
 * correção automática (no próprio anúncio ou recriando) e histórico.
 * Leitura devolve null em falha (a tela mostra o erro com "Tentar de novo");
 * escrita propaga o erro para a tela mostrar a mensagem do servidor.
 */
export const getSaudeAnunciosPainel = async (params = {}) => {
    try {
        const res = await api.get("/saude-anuncios/painel", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar o painel da saúde dos anúncios:", error);
        return null;
    }
};

export const getSaudeAnunciosItens = async (params = {}) => {
    try {
        const res = await api.get("/saude-anuncios/itens", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar os anúncios com problema:", error);
        return null;
    }
};

export const getSaudeAnunciosItem = async (id) => {
    try {
        const res = await api.get(`/saude-anuncios/itens/${id}`);
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar o detalhe do anúncio:", error);
        return null;
    }
};

/** forcar=true: reativar com preço fora do normal (cura revisar_preco) ou reprocessar falhou/manual. */
export const corrigirSaudeAnuncioItem = async (id, body = {}) => {
    const res = await api.post(`/saude-anuncios/itens/${id}/corrigir`, body);
    return res.data;
};

export const ignorarSaudeAnuncioItem = async (id, body = {}) => {
    const res = await api.post(`/saude-anuncios/itens/${id}/ignorar`, body);
    return res.data;
};

export const reabrirSaudeAnuncioItem = async (id) => {
    const res = await api.post(`/saude-anuncios/itens/${id}/reabrir`);
    return res.data;
};

export const getSaudeAnunciosAcoes = async (params = {}) => {
    try {
        const res = await api.get("/saude-anuncios/acoes", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar o histórico da saúde dos anúncios:", error);
        return null;
    }
};

export const getSaudeAnunciosExecucoes = async (params = {}) => {
    try {
        const res = await api.get("/saude-anuncios/execucoes", { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar as execuções da saúde dos anúncios:", error);
        return null;
    }
};

export const getSaudeAnunciosConfig = async () => {
    try {
        const res = await api.get("/saude-anuncios/configuracao");
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar a configuração da saúde dos anúncios:", error);
        return null;
    }
};

/** Só os campos alterados: o servidor aceita qualquer subconjunto dos editáveis. */
export const salvarSaudeAnunciosConfig = async (body) => {
    const res = await api.put("/saude-anuncios/configuracao", body);
    return res.data;
};

/** conta null = todas as contas atendidas. */
export const varrerSaudeAnuncios = async (body = {}) => {
    const res = await api.post("/saude-anuncios/varrer", body);
    return res.data;
};

export const retomarIaSaudeAnuncios = async () => {
    const res = await api.post("/saude-anuncios/ia/retomar");
    return res.data;
};

/**
 * Métricas de Anúncios: visitas, vendas, receita e lucro por anúncio e conta, e o experimento Premium x Clássico.
 * Leitura devolve null em falha (a tela mostra o erro com "Tentar de novo").
 */
const getMetricasAnuncios = async (caminho, params = {}) => {
    try {
        const res = await api.get(`/metricas-anuncios${caminho}`, { params });
        return res.data;
    } catch (error) {
        console.error("Erro ao carregar as métricas de anúncios:", error);
        return null;
    }
};

export const getMetricasAnunciosPainel = (params) => getMetricasAnuncios("/painel", params);
export const getMetricasAnunciosLista = (params) => getMetricasAnuncios("/anuncios", params);
export const getMetricasAnuncio = (idMl) => getMetricasAnuncios(`/anuncios/${encodeURIComponent(idMl)}`);
export const getMetricasAnuncioCalculo = (idMl) => getMetricasAnuncios(`/anuncios/${encodeURIComponent(idMl)}/calculo`);
export const getMetricasAnunciosExperimento = (params) => getMetricasAnuncios("/experimento", params);
export const getMetricasAnunciosTrocas = () => getMetricasAnuncios("/trocas");
